import enInvoices from '../views/invoices/language/enInvoices'
import enCategory from '../views/category/language/enCategory'
import enItem from '../views/item/language/enItem'
import enPriceTable from '../views/priceTable/language/enPriceTable'
import enItemPrice from '../views/itemPrice/language/enItemPrice'
import enSplit from '../views/split/language/enSplit'
import enQuote from '../views/quote/language/enQuote'
import enVendors from '../views/vendor/language/enVendors'
import enCharge from '../views/charge/language/enCharge'
import enHostRating from '../views/hostRating/language/enHostRating'
import enHausefulUsers from '../views/hausefulUsers/language/enHausefulUsers'
import enMapDrawing from '../views/mapDrawing/language/enMapDrawing'
import enImpersonate from "@/components/impersonate/language/enImpersonate"
import enServiceProviders from '../views/serviceProvider/language/enServiceProviders'
import enFinancialReport from '../views/financialReport/language/enFinancialReport'
import enDivergence from '../views/divergence/language/enDivergence'

const enGroup = {
  pages: {
    title: {
      map: 'Map',
      maps: 'Maps',
      groupMap: 'Group map',
      operationMap: 'Operation map',
      customerList: 'Customers',
      board: 'Service Dashboard',
      receivedInvoices: 'Received invoices',
      invoices: 'Invoices',
      invoicesHosts: 'Host Invoices',
      invoicesHauseful: 'Hauseful Invoices',
      adminInvoicesHosts: 'Invoice tracking for hosts',
      missions: 'Missions',
      missionProgress: 'Mission Progress',
      hosts: 'Hosts',
      cities: 'Cities',
      appointmentList: 'Appointment History',
      modelsInspections: 'Binding reporting templates',
      appointmentDetails: 'Appointment Details',
      rechargeList: 'Refills',
      chargeList: 'Charges',
      movementList: 'Balance',
      realtyList: 'Properties',
      reports: 'Reports',
      error404: 'Page not found',
      hausefulUsers: 'Hauseful Users',
      hostOnboarding: 'Host Onboarding',
      hostAppointmentsList: 'Host Services',
      users: 'Users',
      branches: 'Branches',
      clients: 'Clients',
      integration: 'Integrations',
      myPlan: 'My plan',
      RealEstateContractList: 'Client Contracts',
      contractDetails: 'Contract Details',
      transfers: 'Transfers',
      transferDetails: 'Transfer Details',
      categoryList: 'Categories',
      itemList: 'Items List',
      priceTable: 'Price Table',
      vendorsList: 'Vendors',
      payments: 'Payments',
      hostInvoices: 'Host Invoices',
      splitConfigurationList: 'Split Configurations',
      questionnaireList: 'Questionnaires',
      questionnaireQuestionsDetails: 'Questionnaire Questions',
      partners: 'Partners',
      announcements: 'Announcements',
      RealEstateBranchList: 'Client Branches',
      appointmentDashboard: 'Appointment Dashboard',
      rentOut: 'Rent Out',
      financial: 'Financial',
      serviceProviders: 'Service Providers',
      serviceProvider: 'Service Provider',
      checkout: 'Checkout',
      auditList: 'Audit List',
      disputeList: 'Review List',
      divergenceList: 'Recalculations and reimbursements',
    },
  },
  genericFilters: {
    label: {
      city: 'City',
      realEstate: 'Real Estate',
      customer: 'Customer',
      host: 'Host',
    },
    selectHour: {
      label: {
        hour: 'Hour',
        preferences: 'Preferences',
        other: 'Other hours',
      },
    },
    orderBy: {
      ASC: 'Oldest first',
      DESC: 'Most recent first',
    },
  },
  realEstate: {
    title: {
      createNewBranch: 'Create New Branch',
    },
    roles: {
      operator: 'Operator',
      surveyor: 'Surveyor',
    },
    subscriptionTypes: {
      TRIAL: 'Trial',
      SINGLE_PURCHASE: 'Single Purchase',
      PREPAID: 'Prepaid',
      PREPAID_SAAS: 'Prepaid SAAS',
      POSTPAID: 'Postpaid',
      POSTPAID_SAAS: 'Postpaid SAAS',
      SUBSCRIPTION_TRIMESTER: '3 months',
      SUBSCRIPTION_SEMESTER: '6 months',
      SUBSCRIPTION_NONAMESTER: '9 months',
      SUBSCRIPTION_YEAR: '12 months',
      SUBSCRIPTION_LIFELONG: 'Lifetime',
    },
    actions: {
      create: 'New Branch',
      confirm: 'Confirm',
      cancel: 'Cancel',
      save: 'Save',
    },
  },
  announcement: {
    modals: {
      confirmDelete: {
        title: 'Remove announcement',
        text: 'Are you sure you want to delete the announcement?',
        buttons: {
          cancel: 'Cancel',
          confirm: 'Confirm',
        },
      },
    },
    label: {
      messages: {
        successCreation: 'Announcement created successfully',
        successDelete: 'Announcement deleted successfully',
      },
      summary: {
        title: 'Title',
        content: 'Message',
        services: 'Services',
        cities: 'Cities',
        hosts: 'Hosts',
        send: 'Send',
        type: 'Type',
        immediately: 'Immediately',
      },
      create: {
        announcementType: 'Recipient type',
        serviceType: 'Service types',
        cities: 'Cities',
        hosts: 'Hosts',
        message: 'Message',
        sendType: 'Send type',
        releaseDate: 'Send date',
        title: 'Title',
        selectHosts: 'Select hosts',
        validation: {
          content: 'Announcement cannot be empty',
        },
        announcementTypes: {
          ALL: 'All',
          HOST: 'Hosts',
          CUSTOMER: 'Customers',
          undefined: '---',
        },
        sendTypes: {
          immediately: 'Immediate',
          scheduled: 'Scheduled',
        },
      },
      list: {
        createdAt: 'Created at',
        releaseDate: 'Send date',
        releaseDateImmediately: 'Immediate',
        type: 'Send to',
        title: 'Title',
        announcementTypes: {
          HOST: 'Hosts',
          CUSTOMER: 'Customers',
          ALL: 'All',
        },
        actions: {
          details: 'Details',
          delete: 'Disable',
        },
      },
    },
    actions: {
      details: 'Show details',
      delete: 'Remove announcement',
      duplicate: 'Duplicate announcement',
    },
  },
  transfer: {
    label: {
      name: 'Name',
      receiver: 'Recipient type',
      host: 'Host',
      createdAt: 'Created at',
      status: 'Status',
      asaasTransferId: 'Transfer ID (Asaas)',
      total: 'Total',
      visualize: 'View transfer',
      retryTransfer: 'Try to launch again',
      transferToSelected: 'Transfer to selected',
      confirmTransfer: 'Confirm transfer',
      executeTransfer: 'Execute transfer',
      generateReport: 'Generate excel',
      transferReport: 'Transfer report',
      appointment: 'Appointment',
    },
    transferStatus: {
      CANCELED: 'Cancelled',
      FAILED: 'Failed',
      PENDING: 'Pending',
      PROCESSING: 'Processing',
      COMPLETED: 'Completed',
      CALCULATED: 'Calculated',
      CUSTOM: 'Custom',
      CHARGEBACK: 'Chargeback',
      DETACHED: 'Detached',
    },
    noData: 'Apply a filter to list the transfers',
    orderBy: {
      ASC: 'A-Z',
      DESC: 'Z-A',
    },
    filter: {
      host: 'Host name',
      vendor: 'Vendor name',
      partner: 'Partner name',
      date: 'Period',
      status: 'Status',
      orderBy: 'Sort by',
      receiverType: 'Recipient type',
    },
    receiverType: {
      HOST: 'Host',
      VENDOR: 'Vendor',
      PARTNER: 'Partner',
    },
    details: {
      transferData: 'Transfer data',
      status: 'Status',
      total: 'Total',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
      asaasId: 'Transfer ID (Asaas)',
      appointment: 'Appointment',
      receiver: 'Recipient',
      invoices: 'Invoices',
      payments: {
        type: 'Type',
        total: 'Total',
        label: 'Payments',
        details: 'Details',
        appointmentCode: 'Appointment code',
        appointmentDate: 'Appointment date',
        createdAt: 'Payment date',
        description: 'Description',
      },
      types: {
        mission: 'Mission',
        appointment: 'Appointment',
        detached: 'Detached',
      },
      history: {
        label: 'Transfer history',
        createdAt: 'Created at',
        status: 'Status',
        description: 'Description',
      },
    },
    hint: {
      wantToTransfer: 'Do you want to transfer the values to the following recipients?',
      successMessage: 'Transfer(s) added to queue successfully!',
    },
  },
  onboarding: {
    register: {
      title: 'Hello! Create an account to continue',
      name: 'Name',
      customerName: 'Company Name',
      email: 'Email',
      phone: 'Phone',
      password: 'Password',
      repeatPassword: 'Repeat password',
      cpf: 'Driver License Number',
      cnpj: 'CNPJ',
      cpfCnpj: 'CPF/CNPJ',
      accountType: {
        business: 'Company or MEI',
        individual: 'Individual',
        error: 'Choose an option',
      },
      creationAccept: 'By creating your account, you agree to our',
      createTerms: 'Terms of Use',
      createAccount: 'Create account',
      alreadyHaveAccount: 'Already have an account',
      isFurnished: 'Do you have furniture?',
      isTrousseau: 'Do you have trousseau?',
      yes: 'Yes',
      no: 'No',
      errors: {
        phone: 'Invalid phone',
        mail: 'Invalid email',
        minimum: 'Needs to be greater',
        cpf: 'Invalid drive license number',
        cnpj: 'Invalid CNPJ',
        passwordMismatch: 'Passwords do not match',
      },
    },
    address: {
      title: "What is your company's address?",
      form: {
        address: 'Address with number',
        addressHint: 'Enter a valid street address and number',
        addressNumber: 'Number',
        addressNumberHint: 'We will identify the number based on the address',
        zipCode: 'ZIP code',
        zipCodeHint: 'We will identify the ZIP code based on the address',
      },
    },
    services: {
      title: 'Choose the service you want to request now; you can request others later',
    },
    plans: {
      title: 'Choose between individual services and recurring plans with discounts!',
      single: {
        title: 'Individual Service',
        description: 'Immediate hiring',
      },
      recurrent: {
        title: 'Plans of 3, 6, and 12 months',
        description: 'Our team will get in touch',
      },
    },
    details: {
      title: 'Property Details',
      description: 'Carefully fill in the private area field. It will be used to calculate the service value.',
    },
    contract: {
      title: 'Contract',
      acceptAndGoToPayment: 'Accept contract and go to payment',
    },
    payment: {
      titleSelect: 'Almost there! Select the payment method',
      description: 'Fill in your payment information',
      amount: 'Amount',
      amountDescription: 'Value generated according to the service and indicated footage.',
      with: 'Pay with',
      pix: {
        title: 'PIX',
        withPix: 'Pay with PIX',
        description: "Use your phone's scanner or copy and paste the PIX code to make the payment",
        status: {
          PENDING: 'Wait a few minutes on this screen until the payment is confirmed',
        },
      },
      creditCard: {
        title: 'Credit Card',
        withCreditCard: 'Pay with Credit Card',
        description: 'Fill in your credit card details',
      },
    },
    card: {
      name: 'Name',
      nameHint: "Enter the cardholder's name",
      number: 'Card Number',
      numberHint: 'Numbers only',
      dueDate: 'Due Date',
      dueDateHint: 'MM/YYYY',
      ccv: 'CCV',
      ccvHint: 'E.g., 123',
    },
    noRecurringPayment: {
      titleFine: 'All good,',
      titleWithUs: "now it's on us!",
    },
    success: {
      createAppointment: 'Schedule service',
      createAnotherTime: 'Schedule later',
      thanksMessage: 'Your account is active',
      confirmationMessage: 'Hauseful has already confirmed all your data. Your account is available with the acquired credits. Shall we schedule the service?',
    },
    actions: {
      next: 'Next',
      previous: 'Previous',
      addCredit: 'Confirm payment',
      chooseAnotherCity: 'Choose another city',
    },
    options: {
      furnished: 'Furnished',
      noFurnished: 'Unfurnished',
      trousseau: 'Has trousseau',
      noTrousseau: 'No trousseau',
    },
  },
  emptyState: {
    noData: 'No items to display',
    noDataDoTheSearch: 'No results found. Do a search to find the desired item',
  },
  dashboard: {
    alert: {
      type: {
        IN_TIME_CANCELLATION: 'Last-minute cancellation',
        OVERPRICED_APPOINTMENT: 'High-value appointment',
        INACTIVE_CUSTOMER: 'Inactive customer',
        SCHEDULING_DECREASE: 'Decrease in scheduled appointments',
      },
      label: {
        description: 'Describe the solution',
      },
      button: {
        moreInformation: 'More information',
        solved: 'Mark as resolved',
      },
      card: {
        description: 'Alert description',
        solutionDescription: 'Solution description',
        date: 'Date',
        client: 'Client',
        code: 'Code',
      },
      popup: {
        confirmation: 'Do you want to close the alert?',
        yes: 'Yes',
        no: 'No',
      },
      errors: {
        requiredSolution: 'Description of the solution is required.',
        minimumCharacters: 'Minimum of 10 characters.',
        maximumCharacters: 'Maximum of 500 characters.',
      },
    },
    cardAppointment: {
      scheduling: 'Scheduling',
      reschedule: 'Rescheduling',
      numberOfReschedules: 'reschedule(s)',
      realty: 'Property',
      user: 'User',
      realtyCode: 'Property code',
      phone: 'Phone',
      host: 'Host',
      name: 'Name',
      realties: 'Properties',
      document: `Driver's license`,
      observation: 'Observation',
      withoutObservation: 'Without observation',
      meetingAddress: 'Meeting location',
      needsAuthorization: 'Needs authorization',
      scheduledBy: 'Scheduled by',
      visitor: 'Tenant',
      cpf: 'Driver License Number',
      birthDate: 'Birth date',
      tenant: 'Tenant/accompanist',
      date: 'Date',
      address: 'Address',
      totalArea: 'Total area',
      privateArea: 'Private area',
      furnished: 'Furniture',
      trousseau: 'Trousseau',
      btnClose: 'Close',
      loading: 'Loading...',
      displacement: 'Bonus',
      client: 'Client',
      additionalData: 'Additional data',
      observations: 'Comments',
      confirmationTitle: 'Confirmation',
      displaceAndAuthorization: 'Bonus and Authorization',
      additionalAddressData: 'Complement',
      scheduledDifference: {
        in: 'in',
        hour: 'hour(s)',
        minutes: 'minute(s)',
        lessThanMinute: 'less than 1 minute',
      },
      yes: 'Yes',
      no: 'No',
      painting: {
        label: 'Painting',
        NEW: 'New',
        WORN: 'Worn out',
        HOST_CRITERIA: "Host's criteria",
      },
      reschedule: 'Reschedule',
      moreDetails: 'More details',
      confirmation: {
        confirmed: 'Confirmed?',
        attendingToAppointment: 'Attending to appointment?',
        keysNeedsAuthorization: 'Keys needs authorization?',
        observations: 'Comments',
        notAnsweredYet: 'The confirmation has not been answered yet',
        sentAt: 'Sent at',
        acceptedDate: 'Accepted Date',
        answeredAt: 'Answered At',
      },
    },
    tabFilter: {
      menu: {
        filter: 'Filter',
        result: 'Result',
      },
      button: {
        applyFilters: 'Apply filters',
        clear: 'Clear',
        hostRoutes: 'Host Routes',
      },
      label: {
        status: 'Status',
        cities: 'Cities',
        serviceType: 'Service type',
        clients: 'Clients',
        hosts: 'Hosts',
        until: 'to',
        search: 'Search by code or realty',
        country: 'Country',
      },
      tableHeaders: {
        date: 'Date',
        status: 'Status',
        type: 'Type',
        info: 'Info',
      },
    },
    navigationPeriod: {
      button: {
        today: 'Today',
        tomorrow: 'Tomorrow',
        week: 'Week',
      },
    },
    notificationsPage: {
      alerts: {
        title: 'Alerts',
        success: 'SUCCESS',
        successfullyMarkedAsResolved: 'Marked as resolved successfully.',
        info: 'INFORMATION',
        infoMessage: '',
        warning: 'WARNING',
        warningMessage: '',
        danger: 'DANGER',
        dangerMessage: '',
      },
    },
    useTheSearch: 'Search the desired item to apply the filter',
  },
  devolus: {
    pendingActions: 'Devolus: Pending actions',
    table: {
      date: 'Date',
      type: 'Type',
      resolution: 'Resolution',
      info: 'Info',
    },
    labels: {
      host: 'Host',
      date: 'Date',
      appointmentDate: 'Appointment date',
      observations: 'Comments',
      address: 'Address',
      solve: 'Solve',
      solved: 'Resolved',
      solvedDate: 'Resolution date',
      devolusHistory: 'Devolution history',
      moreDetails: 'More details',
      createdAt: 'Created at',
      eventDate: 'Event date',
      errorMessage: 'Error message',
      user: 'User',
      keyPicker: 'Key responsible',
      keyLocation: 'Key withdrawal',
      keyAddress: 'Key address',
      createdBy: 'Created by',
      filters: 'Filters',
      resolved: 'Resolved Devolus actions',
      notResolved: 'Unresolved Devolus actions',
    },
    errors: {
      ERROR_REALTY: 'Error with realty',
      ERROR_USER: 'Error with user',
      ERROR_REAL_ESTATE: 'Error with realty',
      ERROR_APPOINTMENT: 'Error with appointment',
      ERROR_INTEGRATION: 'Error with integration',
      ERROR_ATTACHMENT: 'Error with attachment',
    },
    modals: {
      appointmentDetails: {
        title: 'Appointment details',
      },
    },
  },
  board: {
    host: 'Host',
    visitor: 'Tenant',
    tenant: 'Tenant/Companion',
    openColumnInfo: 'Services being offered to hosts',
    scheduledColumnInfo: 'Accepted services, pending execution or in progress',
    canceledColumnInfo: 'Canceled appointments',
    doneColumnInfo: 'Done services',
    outputs: 'Deliverables',
    realties: 'Properties',
    columnInfo: {
      OPEN: 'Services being offered to hosts',
      SCHEDULED: 'Accepted services, pending execution or in progress',
      CANCELED: 'Canceled appointments',
      DONE: 'Done services',
    },
    badges: {
      hasStarted: 'In Progress',
      canceledByHost: 'Canceled by host',
      notConfirmed: 'Not confirmed',
    },
    actions: {
      reschedule: 'Reschedule',
      visualize: 'View',
      cancel: 'Cancel',
      editVisitor: 'Edit tenant',
      editTenant: 'Edit tenant',
      dispute: 'Report view',
    },
    emptyState: {
      title: 'Click here to schedule your first service',
      createAppointment: 'Schedule service',
    },
    card: {
      urgent: 'URGENT',
    },
  },
  integration: {
    list: 'Integration listing',
    buttons: {
      add: 'Add Integration',
      update: 'Edit Integration',
      save: 'Save',
    },
    externalSources: {
      VISTA: 'Vista',
      BROGNOLI: 'Brognoli',
    },
    label: {
      externalSource: 'Source',
      apiUrl: 'URL',
      keyCode: 'Key',
      status: 'Status',
      apiUser: 'User',
      active: 'Active',
      inactive: 'Inactive',
      pushEnabled: 'Send properties to Loft',
    },
    hint: {
      pushEnabled: 'When enabled, properties created, edited and deleted in Hauseful are mirrored into Loft.',
    },
    warnings: {
      pushEnabled: 'From then on changes leave Hauseful for the real estate\'s live base in Loft, deletions included, which are permanent there.',
    },
    rules: {
      required: 'Required field',
      apiUrl: "Invalid URL (make sure it includes 'http' or 'https' and '/' at the end)",
    },
    toaster: {
      success: {
        updated: 'Integration updated successfully!',
        created: 'Integration created successfully!',
      },
    },
    table: {
      loading: 'Loading... Please wait',
      noData: 'No results',
    },
  },
  hostAppointments: {
    headers: {
      host: 'Host',
      servicesQuantity: 'Quantity of services',
      totalValue: 'Total value',
      squareMetersTotal: 'Total square meters',
    },
    label: {
      services: 'Types of services performed',
      host: 'Host',
      servicesQuantity: 'Quantity of services',
      totalValue: 'Total value',
      squareMetersTotal: 'Total square meters',
    },
  },
  contract: {
    noData: 'No results',
    creationSuccessMessage: 'Contract created successfully!',
    realEstateHasNoActiveContract: 'Real estate does not have an active contract',
    label: {
      subscriptionTypes: {
        TRIAL: 'Trial',
        PREPAID: 'Prepaid',
        PREPAID_SAAS: 'Prepaid SAAS',
        POSTPAID: 'Postpaid',
        POSTPAID_SAAS: 'Postpaid SAAS',
        SINGLE_PURCHASE: 'Single purchase',
        SUBSCRIPTION_TRIMESTER: '3 months',
        SUBSCRIPTION_SEMESTER: '6 months',
        SUBSCRIPTION_NONAMESTER: '9 months',
        SUBSCRIPTION_YEAR: '12 months',
        SUBSCRIPTION_LIFELONG: 'Lifelong',
      },
      isActive: {
        true: 'Active',
        false: 'Inactive',
      },
      monthlyAmount: 'Monthly amount (Capacity)',
      monthlyCapacity: 'Monthly volume (Capacity)',
      dailyCapacity: 'Monthly value (Capacity)',
      overuseFee: 'Fee per inspection above the volume',
      overuseFeePlaceholder: 'Empty charges nothing',
      startDate: 'Start date',
      endDate: 'Expiration date',
      validity: 'Validity',
      contractType: 'Contract type',
      realEstate: 'Real estate',
      date_created: 'Creation date',
      createdBy: 'Created by',
      type: 'Plan',
      is_active: 'Status',
      details: 'Contract Details',
      serviceType: 'Service type',
      price: 'Price',
      discount: 'Discount',
      squareMetersPrice: 'Price per m²',
      baseSquareMetersPrice: 'Base m² size',
      taxHost: 'Host Tax',
      displacementTax: 'Bonus tax',
      taxSquareMeters: 'Tax per m²',
      furnitureTax: 'Furniture tax',
      semiFurnitureTax: 'Semi-furnished tax',
      houseTax: 'House tax',
      trousseauTax: 'Trousseau tax',
      hostRealtyFeatureTax: 'Host tax on property features',
      urgencyTax: 'Urgency Tax',
      urgencyHoursLimit: 'Urgency limit in hours',
      hostRealtyFeatureTax: 'Host tax on urgency',
      values: 'Values',
    },
    details: {
      services: 'Services',
      price: 'Price',
      hostTax: 'Host Tax',
      discount: 'Discount',
      squareMetersPrice: 'Price per private area square meter',
      squareMetersTax: 'Private area square meter tax',
      baseSquareMetersPrice: 'Base calculation size',
      furnitureTax: 'Furniture tax',
      semiFurnitureTax: 'Semi-furnished tax',
      houseTax: 'House tax',
      trousseauTax: 'Trousseau tax',
      displacementTax: 'Bonus tax',
      hostRealtyFeatureTax: 'Host tax on property features',
      urgencyTax: 'Urgency Tax',
      urgencyHoursLimit: 'Urgency limit in hours',
      hostRealtyFeatureTax: 'Host tax on urgency',
    },
    actions: {
      next: 'Next',
      back: 'Back',
      addServiceContract: 'Add service',
      editServiceContract: 'Edit service',
      addService: 'Add',
      editService: 'Update',
      createContract: 'Create contract',
      copyContract: 'Copy contract',
      details: 'Details',
    },
  },
  appointment: {
    divergenceType: {
      AREA: 'Incorrect area',
      FURNITURE: 'Furniture',
      TROUSSEAU: 'Trousseau',
      DISPLACEMENT: 'Displacement',
    },
    label: {
      appointmentCode: 'Appointment Code',
      code: 'Code',
      realtiesCode: 'Real Estate Code',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      type: 'Type',
      origin: 'Origin',
      status: 'Status',
      files: 'Files',
      terminationTerms: 'Termination Terms',
      terminationTerm: 'Termination Term',
      signedTerm: 'Signed',
      notSignedTerm: 'Not Signed',
      outputs: 'Appointment Result Files',
      reason: 'Reason',
      cancelled: 'Cancelled',
      date: 'Appointment Date',
      dateLean: 'Date',
      description: 'Description',
      cancelDate: 'Cancellation Date',
      cancellation: 'Cancellation',
      divergenceRecalculation: 'Divergence recalculation',
      divergenceTypes: 'Confirmed divergences',
      divergenceContestDeadline: 'Deadline to dispute',
      divergenceContestNoDeadline: 'No deadline set',
      divergenceContestExpired: 'The deadline to dispute this recalculation has passed.',
      deleteFile: 'Delete File',
      deleteAllFiles: 'Delete All Files',
      deleteSelectedFiles: 'Delete Selected Files',
      hostData: 'Host Data',
      hostName: 'Host',
      hostPhone: 'Phone',
      hostMail: 'Email',
      hostRg: 'ID',
      externalCode: 'External Code',
      cancellationOrigin: 'Cancellation Origin',
      cancelReason: 'Cancellation Description',
      displacement: 'Bonus',
      operator: 'Operator',
      authorization: 'Authorization',
      download: 'Download',
      replace: 'Replace',
      showOnClickSign: 'View on Clicksign',
      showClickSignSignatures: 'View Signatories',
      branch: 'Branch/Property Manager',
      needsAuthorization: {
        question: 'Needs Authorization?',
        yes: 'Yes',
        no: 'No',
      },
      realEstate: 'Real Estate',
      scheduledBy: {
        name: 'Organizer',
        phone: 'Organizer Phone',
      },
      realties: 'Properties',
      realtyCode: 'Code',
      realtyCodes: 'Realty codes',
      realtyAddress: 'Address',
      realtyAddressAdditional: 'Additional Address',
      realtyDescription: 'Description',
      meetingLocation: 'Meeting Location',
      meetingLocationDescription: 'Meeting Address',
      observations: 'Comments',
      additionalValue: 'Additional Value',
      hostValue: 'Host Value',
      keyPicker: 'Key Pickup',
      keyLocation: 'Key Pickup Location',
      keyLocationDescription: 'Key Address',
      visitorData: 'Tenant Data',
      tenantData: 'Tenant/Companion Data',
      visitorName: 'Name',
      visitorPhone: 'Phone',
      visitorMail: 'Email',
      today: 'Today',
      selectedRealty: 'Selected Real Estate:',
      selectedRealties: 'Selected Real Estates:',
      privateArea: 'Private Area',
      totalArea: 'Total Area',
      squareMetersSymbol: 'm²',
      fci: 'FCI',
      downloadAdditive: 'Download Additive',
      serviceStatus: 'Service Status',
      updateFci: 'Edit FCI',
      value: 'Value',
      yes: 'Yes',
      no: 'No',
      slotSize: 'Slot Size',
      confirmation: {
        confirmed: 'Confirmed',
        rejected: 'Rejected',
        emailSent: 'Confirmation email sent',
        emailNotSent: 'Confirmation email not sent',
        keysNeedsAuthorization: 'Keys need authorization',
        keysDoesNotNeedAuthorization: 'Keys do not need authorization',
        attendingToAppointment: 'Will attend the appointment',
        notAttendingToAppointment: 'Will not attend the appointment',
        notAnsweredYet: 'Not answered yet'
      },
      addToGroup: {
        title: 'Add appointments to group',
        message: 'Select the group to add the appointments.',
        addThisAppointmentsToGroup: 'Add the selected appointments to the group',
        add: 'Add appointment(s)',
        cancel: 'Cancel',
      },
      workerType: 'Worker type',
    },
    statusTable: {
      details: 'Details',
      code: 'Code',
      isServiceDone: 'Service Done?',
      comment: 'Comment',
      address: 'Address',
      reasonNotPerformed: 'Reason for Not Performed',
      billable: 'Billable?',
      reopen: 'Reopened?',
      photos: 'Photos',
      type: 'Type',
      realized: {
        true: 'Done',
        false: 'Not done',
      },
      reasonType: {
        HOST: 'Host',
        CUSTOMER: 'Customer',
        THIRD_PARTY: 'Other',
      },
    },
    buttons: {
      add: 'Add Appointment',
      deleteAll: 'Delete All',
      deleteSelected: 'Delete Selected',
      moreDetails: 'More Details',
      showSummary: 'Summary',
      generateExcel: 'Generate Excel',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
    adminExcel: {
      fileName: 'Appointments',
    },
    needsAuthorizationInfo: 'If authorization is needed, specify and have it ready for the host to use',
    cancellationOrigin: {
      BY_HOST_NOT_HAPPENED: 'Did not happen',
      BY_HOST_NOT_GOING: 'Host dropped out',
      BY_REAL_ESTATE: 'By the real estate agency',
      BY_REAL_ESTATE_EXPIRATION: 'Expiration time',
      BY_ADMIN: 'By the administrator',
      BY_CS: 'By support',
    },
    meetingLocation: {
      REAL_ESTATE: 'Branch',
      REALTY: 'Property',
      OTHER: 'Other',
    },
    keyPicker: {
      HOST: 'Host',
      VISITOR: 'Tenant',
      NOT_NEEDED: 'Not needed',
      undefined: '---',
    },
    keyLocation: {
      REAL_ESTATE: 'Branch',
      REALTY: 'Property',
      SMART_BOX: 'SmartBox',
      OWNER: 'Property Owner',
      OTHER: 'Other',
    },
    filters: {
      noData: 'No results',
      typeToSearchRealEstate: 'Type to search for a customer',
      status: 'Status',
      type: 'Type',
      sort: 'Sort',
      branch: 'Branch',
      search: 'Search',
      period: 'Period',
      cities: 'Cities',
      hosts: 'Hosts',
      selectDate: 'Select a date',
      subscriptionType: 'Plan',
      sortBy: {
        ASC: 'Oldest first',
        DESC: 'Newest first',
      },
      buttons: {
        reset: 'Clear',
        applyFilters: 'Apply filters',
      },
      datePicker: {
        selectedItems: '2 selected',
      },
      confirmed: 'Confirmed',
      notConfirmed: 'Not confirmed',
      confirmationEmailSent: 'Confirmation email sent',
      sent: 'Sent',
      notSent: 'Not sent',
      workerType: 'Worker types',
    },
    table: {
      loading: 'Loading... Please wait',
      noData: 'No results',
      showExtraFields: 'Show extra fields',
    },
    status: {
      OPEN: 'Awaiting Host',
      SCHEDULED: 'Scheduled',
      DONE: 'Done',
      CANCELED: 'Canceled',
      DRAFT: 'Draft',
      REJECTED: 'Rejected',
      PARTNER_OPEN: 'Open',
      ACCEPTED: 'Accepted',
      undefined: '---',
    },
    partnerStatus: {
      DRAFT: 'Draft',
      REJECTED: 'Rejected',
      OPEN: 'Open',
    },
    type: {
      VISIT: 'Visit',
      VISIT_PREMIUM: 'Premium Visit',
      PHOTOGRAPHY: 'Photography',
      PHOTOGRAPHY_PREMIUM: 'Premium Photography',
      PHOTOGRAPHY_360: '360° Photography',
      KEY_DELIVERY: 'Key Delivery',
      INSPECTION: 'Entry Inspection Gold',
      DISPLACEMENT: 'Bonus',
      DRONE: 'Drone',
      LOFT_VISIT: 'Loft Visit',
      INSPECTION_ENTRANCE: 'Entry Inspection',
      INSPECTION_ENTRANCE_PREMIUM: 'Premium Entry Inspection',
      INSPECTION_EXIT: 'Exit Inspection',
      INSPECTION_EXIT_GOLD: 'Exit Inspection Gold',
      INSPECTION_EXIT_PREMIUM: 'Premium Exit Inspection',
      INSPECTION_INTERMEDIARY: 'Intermediary Work Inspection',
      INSPECTION_DELIVERY: 'Work Delivery Inspection',
      INSPECTION_MEASUREMENT: 'Measurement Inspection',
      INSPECTION_AUDITANCE: 'Audit of Inspection',
      REINSPECTION: 'Reinspection',
      REINSPECTION_HAUSEFUL: 'Reinspection Hauseful',
      TECHNICAL_SKETCH: '2D Premium Survey',
      TECHNICAL_SKETCH_PLUS: '2D Plus Survey',
      PLANNING: 'Planning',
      IMAGE_EDITING: 'Image Editing',
      REALTY_SUGGESTION: 'Property Suggestion',
      REMOTE_VISIT: 'Remote Visit',
      SKETCH: '3D Survey',
      INSPECTION_ENTRANCE_PLUS: 'Entry Inspection Plus',
      INSPECTION_EXIT_PLUS: 'Exit Inspection Plus',
      INSPECTION_MINI: 'Mini Entry Inspection',
      VISIT_GOLD: 'Gold Entry Visit',
      INSPECTION_CONSTRUCTION_INTERMEDIARY: 'Construction Supervision - Intermediary',
      INSPECTION_CONSTRUCTION_FINAL: 'Construction Supervision - Final',
      INSPECTION_CONFERRING_ENTRANCE: 'Entry Inspection - Conference',
      INSPECTION_ENTRANCE_HOUSEVIEW: 'Entry Inspection - Houseview',
      INSPECTION_EXIT_HOUSEVIEW: 'Exit Inspection - Houseview',
      MAPPING_FOR_EVALUATION: 'Information Mapping',
      TERMINATION: 'Termination',
      RENT_OUT: 'Facilitated Termination',
      RENT_OUT_DUDA: 'Facilitated Termination - Duda Real Estate',
      DELIVERY: 'Delivery',
      INSPECTION_POST_INSTALLATION: 'Installation Inspection',
      INSPECTION_AND_ESTIMATE: 'Inspection + Estimate',
      INSPECTION_SHED: 'Shed Inspection - Entrance',
      INSPECTION_SHED_EXIT: 'Shed Inspection - Exit',
      INSPECTION_IMOBMIX_ENTRANCE: 'IMOBMIX Inspection - Entrance',
      INSPECTION_IMOBMIX_EXIT: 'IMOBMIX Inspection - Exit',
      PHOTOGRAPHY_PLUS: 'Plus Photography',
      PHOTOGRAPHY_HAUSEFUL: 'Hauseful Photography',
      PHOTOGRAPHY_HOME_STAGING: 'Gold Photography',
      VISIT_AND_PHOTOS: 'Visit + Photography',
      VISIT_LIGHT: 'Light Visit',
      VISIT_SALE: 'Sales Visit',
      TRAINING: 'Practical Training',
      MISSION: 'Missions',
      PHOTOGRAPHY_PREMIUM_PLUS_360: 'Premium Photography + 360',
      OBSERVED_TRAINING: 'Observed Training',
      DUMP: 'Abandonment Confirmation',
      EVICTION: 'Eviction - Keys',
      INSPECTION_TEST: 'Test Inspection',
      INSPECTION_IB_ENTRANCE: 'IB Entrance Inspection',
      INSPECTION_IB_EXIT: 'IB Exit Inspection',
      INSPECTION_MINI_EXIT: 'Mini Exit Inspection',
      INSPECTION_MINI_EXIT_GOLD: 'Mini Gold Exit Inspection',
      INSPECTION_MINI_EXIT_PLUS: 'Mini Exit Plus Inspection',
      INSPECTION_MINI_ENTRANCE_GOLD: 'Mini Gold Entrance Inspection',
      INSPECTION_MINI_ENTRANCE_PLUS: 'Mini Entrance Plus Inspection',
      INSPECTION_ENTRANCE_BACKLOG: 'Entry Inspection - Backlog',
      INSPECTION_EXIT_BACKLOG: 'Exit Inspection - Backlog',
      INSPECTION_ENTRANCE_ANTICIPATION: 'Entry Inspection - Anticipation',
      INSPECTION_INSURER: "Insurers' Confirmation Inspection",
      LEASED_PROPERTY_CONFERENCE_ENTRANCE: 'Leased Property Conference - Entrance',
      LEASED_PROPERTY_CONFERENCE_INTERMEDIARY: 'Leased Property Conference - Intermediary',
      LEASED_PROPERTY_CONFERENCE_EXIT: 'Leased Property Conference - Exit',
      DEBT_NOTIFICATION: 'Debt Notification',
      PHOTOGRAPHY_PLUS_FOTOP: 'Photography Plus Fotop',
      PHOTOGRAPHY_PREMIUM_FOTOP: 'Premium Photography Fotop',
      INSPECTION_ENTRANCE_GOLD_ONE_OFF: 'Entrance inspection Gold - One-off',
      INSPECTION_EXIT_GOLD_ONE_OFF: 'Checkout inspection Gold - One-off',
      ROUTINE_INSPECTION: 'Routine inspection',
      INGOING_INSPECTION: 'Ingoing inspection',
      OUTGOING_INSPECTION: 'Outgoing inspection',
      VIRTUAL_TOUR: 'Virtual tour',
      INGOING_INSPECTION_VIRTUAL_TOUR: 'Ingoing inspection + Virtual tour',
      REVISION_INSPECTION: 'Revision inspection',
      MEASURE_AND_CAPTURE: 'Measure and Capture',
      INGOING_APARTMENT_THREE_BEDS: 'Ingoing - Apartments up to 3 Beds',
      INGOING_APARTMENT_FOUR_PLUS_BEDS: 'Ingoing - Apartments 4 Beds +',
      INGOING_HOUSE_THREE_BEDS: 'Ingoing - House Up to 3 Beds',
      INGOING_HOUSE_FOUR_BEDS: 'Ingoing - House 4 Beds',
      INGOING_HOUSE_FIVE_PLUS_BEDS: 'Ingoing - House 5 Beds +',
      OUTGOING_APARTMENT_THREE_BEDS: 'Outgoing - Apartments up to 3 Beds',
      OUTGOING_APARTMENT_FOUR_PLUS_BEDS: 'Outgoing - Apartments 4 Beds +',
      OUTGOING_HOUSE_THREE_BEDS: 'Outgoing - House Up to 3 Beds',
      OUTGOING_HOUSE_FOUR_BEDS: 'Outgoing - House 4 Beds',
      OUTGOING_HOUSE_FIVE_PLUS_BEDS: 'Outgoing - House 5 Beds +',
      QUESTIONNAIRE: 'Questionnaire',
      GONDOLA: 'Gondola',
      INSPECTION_ENTRANCE_SHORTSTAY: 'Shortstay entrance inspection',
      INSPECTION_EXIT_SHORTSTAY: 'Shortstay exit inspection',
      INGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR: 'Ingoing - Apartments up to 3 Beds and Virtual Tour',
      INGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR: 'Ingoing - Apartments 4 Beds +  and Virtual Tour',
      INGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR: 'Ingoing - House Up to 3 Beds  and Virtual Tour',
      INGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR: 'Ingoing - House 4 Beds  and Virtual Tour',
      INGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR: 'Ingoing - House 5 Beds +  and Virtual Tour',
      OUTGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR: 'Outgoing - Apartments up to 3 Beds  and Virtual Tour',
      OUTGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR: 'Outgoing - Apartments 4 Beds +  and Virtual Tour',
      OUTGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR: 'Outgoing - House Up to 3 Beds  and Virtual Tour',
      OUTGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR: 'Outgoing - House 4 Beds  and Virtual Tour',
      OUTGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR: 'Outgoing - House 5 Beds +  and Virtual Tour',
      HAUSEFUL_ENTRANCE: 'Hauseful entrance inspection',
      HAUSEFUL_EXIT: 'Hauseful exit inspection with comparison',
      HAUSEFUL_EXIT_WITHOUT_COMPARISON: 'Hauseful exit inspection without comparison',
      INSPECTION_ABANDONMENT_HAUSEFUL: 'Abandonment inspection - Hauseful',
      INSPECTION_GIACOMELLI_ENTRANCE: 'Giacomelli inspection - Entrance',
      INSPECTION_GIACOMELLI_EXIT: 'Giacomelli inspection - Exit',
      INSPECTION_PRELIMINARY: 'Precautionary inspection',
      INSPECTION_PRELIMINARY_TYPE_ONE: 'Precautionary inspection - Type 1',
      INSPECTION_PRELIMINARY_TYPE_TWO: 'Precautionary inspection - Type 2',
      INSPECTION_PRELIMINARY_TYPE_THREE: 'Precautionary inspection - Type 3',
      INSPECTION_ENTRANCE_REDEPLAN: 'Entrance Inspection - Redeplan',
      INSPECTION_EXIT_REDEPLAN: 'Exit Inspection - Redeplan',
      INSPECTION_INTERMEDIARY_REDEPLAN: 'Intermediary Inspection - Redeplan',
      INSPECTION_ROUTINE_PLUS_VIRTUAL_TOUR: 'Routine inspection + Virtual Tour',
      INSPECTION_INGOING_STUDIO: 'Ingoing - Studio',
      AIRBNB_CLEANING: 'Airbnb Cleaning',
      HEAVY_CLEANING_POST_CONSTRUCTION: 'Heavy Cleaning Post-Construction',
      INSPECTION_ENTRANCE_BRASILIA_IMOVEIS: 'Brasília Imóveis entrance inspection',
      INSPECTION_EXIT_BRASILIA_IMOVEIS: 'Brasília Imóveis exit inspection',
      REINSPECTION_BRASILIA_IMOVEIS: 'Brasília Imóveis reinspection',
      INSPECTION_ENTRANCE_NEGRAO: 'J. Negrão entrance inspection',
      INSPECTION_EXIT_NEGRAO: 'J. Negrão exit inspection',
      REINSPECTION_NEGRAO: 'J. Negrão reinspection',
      INSPECTION_ENTRANCE_LIGHT: 'Entrance inspection - Light',
      INSPECTION_EXIT_LIGHT_WITH_COMPARISON: 'Exit inspection with comparison - Light',
      INSPECTION_EXIT_LIGHT_WITHOUT_COMPARISON: 'Exit inspection without comparison - Light',
      REINSPECTION_LIGHT: 'Reinspection - Light',

      INSPECTION_ENTRANCE_LAVIERI: 'Entrance inspection - Lavieri',
      INSPECTION_EXIT_LAVIERI: 'Exit inspection - Lavieri',
      REINSPECTION_LAVIERI: 'Reinspection - Lavieri',

      INSPECTION_ENTRANCE_SANTA_ILHA: 'Entrance inspection - Santa Ilha',
      INSPECTION_EXIT_SANTA_ILHA: 'Exit inspection - Santa Ilha',
      REINSPECTION_SANTA_ILHA: 'Reinspection - Santa Ilha',

      INSPECTION_ENTRANCE_DOMINAI: 'Entrance inspection - Dominai',
      INSPECTION_EXIT_DOMINAI: 'Exit inspection - Dominai',
      REINSPECTION_DOMINAI: 'Reinspection - Dominai',
      QUALITY_INSPECTION: 'Quality inspection',
      QUALITY_REINSPECTION: 'Quality reinspection',
      VISIT_CHARLIE: 'Visit - Charlie',
      REPOSSESSION: 'Repossession',
      REGISTRATION_FORM: 'Registration form',
      PROPERTY_CAPTURE: 'Property capture',

      INSPECTION_ENTRANCE_CHARLIE: 'Entrance inspection - Charlie',
      INSPECTION_EXIT_CHARLIE: 'Exit inspection - Charlie',
      REGISTRATION_AUTHORITY_INSPECTION: 'Registration Authority inspection',
      INSPECTION_EXIT_DL_WITH_COMPARISON: 'Exit inspection with comparison (DL)',
      INSPECTION_PRELIMINARY_ROMA: 'Preliminary inspection - Roma',
      INSPECTION_PRELIMINARY_HAUSEFUL: 'Hauseful preliminary inspection',
      INSPECTION_DELIVERY_BUILDER: 'Construction delivery inspection - Builder',
      AGENDA_FORM: 'Agenda form',
      VISIT_IBAGY: 'Visit - Ibagy',
      VISIT_RENASCENCA: 'Visit - Renascença',
      PROPERTY_CAPTURE_RENASCENCA: 'Property capture - Renascença',
      INSPECTION_DELIVERY_STANDARD: 'Construction delivery inspection - Standard',
      INSPECTION_DELIVERY_MEDIUM: 'Construction delivery inspection - Medium',
      INSPECTION_DELIVERY_HIGH_STANDARD: 'Construction delivery inspection - High standard',
      PREVENTIVE_RECORD: 'Preventive record',
      PREVENTIVE_RECORD_TYPE_ONE: 'Preventive record type 1',
      PREVENTIVE_RECORD_TYPE_TWO: 'Preventive record type 2',
      PREVENTIVE_RECORD_TYPE_THREE: 'Preventive record type 3',
      INSPECTION_ROUTINE_REPORT_PROPERFY: 'Properfy - Routine inspection report',
      INSPECTION_NEUTRAL_MODEL_DOMINAI: 'Neutral model - Dominai',
    },
    history: {
      label: {
        code: 'Code',
        type: 'Service',
        realtiesCode: 'Properties',
        status: 'Status',
        date: 'Date',
        cancelDate: 'Cancellation',
        hostName: 'Host',
        appointmentData: 'Appointment Data',
        staus: 'Status',
        additionalAmount: 'Additional Value',
        origin: 'Origin',
        observations: 'Comments',
        rescheduleReason: 'Reschedule reason',
        authorData: "Author's Data",
        authorName: 'Name',
        authorPhone: 'Phone',
        authorEmail: 'Email',
        description: 'Action Description',
        visitorName: 'Tenant name',
        visitorPhone: 'Tenant phone',
        confirmed: 'Confirmed',
        confirmationComment: 'Confirmation comment',
        customer: 'Customer',
        branch: 'Branch',
        attendingToAppointment: 'Attending to appointment',
        keysNeedsAuthorization: 'Keys needs authorization',
        additionalData: 'Additional data',
        confirmations: 'Confirmations',
        groupCode: 'Group code',
        group: 'Group',
        serviceProviderUser: 'Worker',
      },
      action: {
        APPOINTMENT_CREATION: 'Appointment created',
        APPOINTMENT_CANCELED_BY_REAL_ESTATE: 'Appointment canceled by agent',
        APPOINTMENT_CANCELED_BY_CS: 'Appointment canceled by support',
        APPOINTMENT_RESCHEDULED_OPEN: 'Open appointment edited',
        APPOINTMENT_RESCHEDULED_SCHEDULED: 'Scheduled appointment edited',
        APPOINTMENT_RESCHEDULED_CANCELED: 'Canceled appointment edited',
        APPOINTMENT_ACCEPTED: 'Appointment accepted',
        APPOINTMENT_STARTED: 'Appointment started',
        APPOINTMENT_FINISHED: 'Appointment finished',
        APPOINTMENT_CANCELED_BY_HOST_NOT_GOING: 'Appointment canceled by host',
        APPOINTMENT_CANCELED_BY_SERVICES_NOT_DONE: 'Appointment canceled due to services not performed',
        APPOINTMENT_DID_NOT_HAPPEN_BY_HOST: "Appointment didn't occur",
        APPOINTMENT_PAYMENT_ON_FINISHED: 'Appointment payment',
        APPOINTMENT_GENERATED_PAYMENT: 'Payment generated',
        APPOINTMENT_FILES_ADDED: 'File added',
        APPOINTMENT_FILES_REMOVED: 'File removed',
        APPOINTMENT_REALTY_ADDED: 'Property added',
        APPOINTMENT_FEEDBACK_BY_REAL_ESTATE: 'Feedback',
        APPOINTMENT_FEEDBACK_BY_VISITOR: "Tenant's feedback",
        APPOINTMENT_CHARGEBACK: 'Payment chargeback',
        APPOINTMENT_CHANGE_HOST: 'Host change',
        APPOINTMENT_CHANGE_STATUS: 'Appointment status change',
        APPOINTMENT_OUTPUT_ADDED: 'Appointment result file added',
        APPOINTMENT_OUTPUT_REMOVED: 'Appointment result file removed',
        APPOINTMENT_QUOTE_REOPENED: 'Quote reopened',
        APPOINTMENT_CHANGE_DATE: 'Appointment date and time change',
        APPOINTMENT_ADDED_TO_GROUP: 'Appointment added to group',
        APPOINTMENT_REMOVED_FROM_GROUP: 'Appointment removed from group',
        APPOINTMENT_CONFIRMED: 'Appointment confirmed',
        APPOINTMENT_UPDATE_OBSERVATIONS: 'Update comments',
        UPDATE_ADDITIONAL_DATA: 'Update additional data',
        undefined: 'Undefined',
        APPOINTMENT_UPDATE_OBSERVATIONS: 'Update comments',
        APPOINTMENT_CHANGE_KEY_OPTIONS: 'Key location change'
      },
      source: {
        API: 'Api',
        APP: 'App',
        WEB: 'Web',
        SYSTEM: 'System',
      },
    },
    field: {
      status: {
        VS_OPEN: 'Open',
        VS_SCHEDULED: 'Scheduled',
        VS_DONE: 'Done',
        VS_CANCELED: 'Canceled',
      },
    },
    formCreate: {
      titles: {
        service: 'Choose the service you want to schedule',
        serviceAndSubs: 'Choose the service and branch to schedule',
        dateTime: 'Choose the date and time to perform the service',
        realtiesSingle: 'Choose a property for the service',
        realtiesMultiple: 'Choose one or more properties for the service',
        realtyTitle: 'Enter the property code or address',
        keyLocation: 'Enter the key location',
        meetingLocation: 'Enter the meeting location',
        keyLocationAndMeeting: 'Enter the key location and meeting place',
        keyResponsible: 'Keyholder',
        authorization: 'Authorization',
        observation: 'Additional value and other information',
        realties: 'Properties',
        realty: 'Property',
        visitor: "Tenant's details",
        tenant: "Tenant's/accompanying person's details",
        terminationFileUpload: 'Upload the termination document',
        terminationFileUploaded: 'Document sent successfully',
        attachments: 'Attachments',
        attachmentsUploaded: 'Attachments uploaded successfully',
        appointmentSuccess: 'Appointment successfully created',
        otherDetails: 'Other details',
        totalAmount: 'Total amount',
      },
      labels: {
        service: 'Service',
        branch: 'Branch',
        realEstate: 'Real estate',
        inspector: 'Inspector',
        noRealty: 'No property found',
        branches: 'Branches',
        displacementAmount: 'Bonus',
        attachmentsHint: 'Upload the documents required for this service.',
        fciAmount: 'FCI',
        realties: 'Properties',
        others: 'Others',
        externalCode: 'External Code',
        date: 'Upcoming days',
        time: 'Best times',
        period: 'Fastest acceptance times',
        location: 'Location',
        address: 'Address',
        streetNumber: 'Number',
        realtyAddress: 'Property address',
        meetingAddress: 'Meeting location',
        realEstateAddress: 'Real estate address',
        addRealties: 'Add properties',
        searchRealty: 'Search property',
        baseReport: 'Base report',
        baseReportHint: 'Previous report of the property used as the comparison reference',
        noBaseReport: 'This property has no finished report available for comparison. This service cannot be scheduled for it.',
        additionalAmount: 'Additional amount',
        displacement: 'Bonus: {entityName}',
        fci: 'FCI: {entityName}',
        needsAuthorization: 'Need authorization to access the property?',
        yesNeedsAuthorization: 'Yes',
        noNeedsAuthorization: 'No',
        keyLocation: 'Key location',
        keyPicker: 'Responsible',
        keyAddress: 'Key location',
        keyAddressRealty: 'Property address',
        keyAddressRealEstate: 'Real estate address',
        searchAddress: 'Search address',
        addAddress: 'Add address',
        updateAddress: 'Update address',
        informStreetNumber: 'Enter the number',
        informPostalCode: 'Enter the ZIP code',
        postalCode: 'ZIP code',
        visitorName: 'Name',
        visitorEmail: 'Email',
        visitorPhone: 'Phone',
        visitorDocument: 'Driver License Number',
        visitorBirthDate: 'Birthdate',
        observations: 'Comments',
        summaryKeyPicker: 'Responsible',
        summaryKeyLocation: 'Pick-up',
        summaryKeyAddress: 'Address',
        noLocationFound: 'No location found',
        removeRealty: 'Remove property',
        type: 'Property type',
        painting: {
          label: 'Painting',
          new: 'New',
          worn: 'Worn',
          hostCriteria: 'Host Criteria',
          host_criteria: 'Host Criteria',
        },
        trousseau: {
          label: 'Trousseau',
          true: 'Yes',
          false: 'No',
        },
        furnished: {
          label: 'Furniture',
          true: 'Yes',
          false: 'No',
        },
        meterage: {
          label: 'Measurement',
          privateArea: 'Private area',
          totalArea: 'Total area',
        },
        periods: {
          label: 'Period',
          allDay: 'All day',
          morning: 'Morning',
          afternoon: 'Afternoon',
        },
        endTime: 'end time',
        to: 'to',
        createRealty: 'Create property',
        newRealty: 'New property',
        uploadText: 'Below, you can attach files to the appointment you just created',
      },
      hints: {
        meetingAddressHint: 'Single available address',
        displacement: 'Our suggestion is to add $1.50 for each Km traveled to the service value',
        fci: 'Property Conservation Fund',
        slotSize: 'The value will be added to the scheduling time, informing the time interval in which the service will be performed (in minutes)',
        minutes: 'minutes',
        visitorEmailReportAccess: 'To access the report, the email must be filled in',
      },
      actions: {
        next: 'Next',
        previous: 'Previous',
        save: 'Create appointment',
        draft: 'Save as draft',
        createNew: 'Create new appointment',
        confirm: 'Apply',
        reschedule: 'Schedule',
        changeHost: 'Change Host',
        changeStatus: 'Change Status',
      },
      errors: {
        name: 'Enter the full name',
        address: 'Incomplete address: Add more details to the address, like the number, neighborhood, city, and state',
        singlePurchase: 'Single services and prepaids must be scheduled at least 48 hours in advance. Please contact support via chat.',
        dateTime: 'Please select the date and time for the service',
        slotSize: 'Only positive numbers or zero are allowed and less than 420 minutes.',
        noHostFound: 'No host found',
        dateTimePeriod: 'Please select the date and period for the service',
        endTimeRequired: 'Inform the service end time',
      },
      summary: {
        title: 'Appointment summary',
        branch: 'Branch',
        inspector: 'Inspector',
        description: 'Here, the summary of your appointment will be displayed',
        serviceAndBranch: 'Service and branch',
        dateTime: 'Date and time',
        realties: 'Properties',
        keyLocation: 'Key location',
        meetingLocation: 'Meeting location',
        otherDetails: 'Other details',
        urgent: 'URGENT',
        urgencyDescription: 'Attention: This service was scheduled less than 24 hours in advance. An additional fee of 50% may be applied to the total amount. If you prefer, you can choose a new date and time to avoid the urgency fee.',
        period: 'Period',
      },
      calendar: {
        title: 'Upcoming appointments',
        prev: 'Previous days',
        next: 'Next days',
        oneDay: '1 day',
        threeDays: '3 days',
        estimatedEnd: 'Estimated end time',
        empty: 'No appointments',
        filters: {
          realty: 'Realty',
          host: 'Worker',
          viewMode: 'View',
          groupHosts: 'Hosts',
          groupInternals: 'Internal',
          groupThirdParties: 'Third party',
        },
      },
    },
    closeModal: {
      title: 'Confirmation',
      text: 'By closing this window, you will lose all the data you have entered. Do you want to close the window?',
      buttons: {
        closeModal: 'Close window',
        cancel: 'Cancel',
      },
    },
    cancelModal: {
      title: 'Cancel',
      confirmationQuestion: 'Do you really want to cancel the appointment?',
      cancelReason: 'Reason for cancellation',
      description: 'Description',
      cancel: 'Cancel appointment',
      code: 'Code',
      type: 'Type',
      date: 'Date',
      visitor: 'Tenant',
      meetingLocation: 'Meeting Location',
      notifyPropertyManager: 'Notify property manager',
      notifyPropertyManagerInfoMessage: 'Only for confirmed appointments',
      appointmentsToRemove: 'The following appointment(s) will be removed from their groups:',
      appointmentsToCancel: 'The following appointment(s) will be canceled:',
    },
    adminAppointmentReschedule: {
      label: {
        observation: 'Comments',
      },
    },
    adminActions: {
      options: 'Options',
      reschedule: 'Reschedule',
      showDetails: 'View',
      removeFromGroup: 'Remove from group',
      changeHost: {
        action: 'Change Host',
        addHost: 'Add Host',
        selectHost: 'Select Host',
        currentHost: 'Current Host',
      },
      changeInspector: {
        action: 'Change inspector',
        setAction: 'Set inspector',
        selectInspector: 'Select inspector',
        currentInspector: 'Current inspector',
        successMessage: 'Inspector updated successfully',
      },
      changeStatus: {
        action: 'Change Status',
        selectStatus: 'Select Status',
        openWarningMessage: 'Changing the status to "{status}" is only possible for appointments that are "Draft", "Scheduled", "Cancelled", "Rejected" or "Done"',
        scheduledWarningMessage: 'Changing the status to "{status}" is only possible for appointments that are "Cancelled" or "Done" and have a host',
        draftWarningMessage: 'Changing the status to "{status}" is only possible for appointments that are "Open" or "Rejected", that do not have a host and do not belong to a group',
        reopenInfoMessage: 'Reopening sends the inspection back to the host to edit in the app. Once they reopen the report, the collected signatures are removed. Host payments, if any, will be charged back.',
      },
      changeType: {
        action: 'Change Service Type',
        selectType: 'Select Service Type',
      },
      changeKeyLocation: {
        action: 'Change Key Location',
        selectKeyLocation: 'Select Key Location',
        selectRealty: 'Select Realty',
        selectBranch: 'Select Branch',
        newKeyAddress: 'New Key Address',
        errorMessage: 'Error changing key location',
      },
      quoteReopen: {
        action: 'Reopen Quote',
        successMessage: 'Quote reopened successfully',
        errorMessage: 'Error reopening quote',
        warningMessage: 'Warning, you are about to reopen an already finalized quote.',
      },
      addHost: {
        action: 'Add Host',
        errorMessage: 'Error adding Host',
        successMessage: 'Host added successfully',
      },
      changeDate: {
        action: 'Change Date and Time',
        errorMessage: 'Error changing scheduling date and time',
        successMessage: 'Scheduling date and time updated successfully',
        warningMessage: 'Warning, you are about to change the date and time of a scheduled appointment.',
      },
      updateObservations: {
        action: 'Change comments',
        successMessage: 'Comments updated successfully',
      },
      updateDisplacement: {
        action: 'Change bonus',
        successMessage: 'Bonus updated successfully',
      },
      confirmAppointmentManually: 'Confirm Appointment Manually',
      additionalInfo: 'Custom fields',
      showConfirmationPage: 'Show confirmation page',
      sendConfirmationEmail: 'Send confirmation email',
      viewReportFiles: 'View report files (S3)',
    },
    details: {
      tabs: {
        details: 'Details',
        history: 'History',
        questionary: 'Questionnaire',
        reportAndQuotes: 'Reports and Quotes',
        financial: 'Financial',
      },
    },
    reschedule: {
      title: 'Reschedule',
      date: 'Date',
      hour: 'Time',
      byHour: 'Exact time',
      byPeriod: 'By period',
      selectPeriod: 'Select period',
      displacement: 'Bonus',
      observation: 'Comments',
      rescheduleReason: 'Reschedule reason',
      rescheduleReasonPlaceholder: 'Enter the reason for rescheduling (optional)',
      pastDate: 'The date has passed',
      cantBeLess: 'Value cannot be less than the current {value}',
    },
    visitor: {
      update: 'Update',
      cancel: 'Cancel',
      updateVisitor: 'Update tenant',
      updateTenant: 'Update tenant/accompanist',
      successfullyUpdated: 'Successfully updated',
      errorWhileUpdating: 'Error while updating',
    },
    messages: {
      fciUpdated: 'FCI updated successfully',
      termReplaced: 'Term replaced successfully',
      fciUpdateError: 'Error updating FCI',
      cantBeLessThanZero: 'Cannot be less than $0.00',
      successfullyCanceled: 'Appointment successfully canceled',
      addedTags: 'Tags added successfully',
      removedTags: 'Tag removed successfully',
      groupCreated: 'Group created successfully',
      appointmentNotFound: 'Appointment not found',
      rescheduled: 'Appointment rescheduled successfully',
      updated: 'Appointment updated successfully',
    },
    print: {
      realty: 'Property',
      appointment: 'Appointment',
      host: 'Host',
      visitor: 'Tenant',
      tenant: 'Tenant/Companion',
      history: 'History',
      doneDate: 'Completion Date',
      questionnaire: 'Questionnaire',
      questionnaireTitle: 'Appointment Questionnaires #{code}',
      questionnaireInfo: '<p class="mb-0">Questionnaire related to appointment <strong>{code}</strong> {externalCode}.</p>',
      hostInfo: '<p class="mb-0">{host} <br /><small>{hostEmail}</small></p>',
      visitorInfo: '<p class="mb-0">{visitor} <br /><small>{visitorEmail}</small> <br /><small>{visitorPhone}</small></p>',
      noExternalCode: 'No external code',
      externalCode: 'External code <strong>{externalCode}</strong>',
    },
    confirmAppointment: {
      title: 'Inspection Confirmation',
      subtitle: "This is the confirmation form for an upcoming home inspection scheduled for the property you're in, at {appointmentAddress}, code {appointmentCode}. Please check the date, time and other information and before confirming it.",
      options: 'Options',
      details: 'Details',
      type: 'Type',
      scheduledBy: 'Property manager',
      date: 'Date',
      status: 'Status',
      code: 'Code',
      tenant: 'Tenant',
      meetingAddress: 'Meeting Address',
      agency: 'Agency',
      name: 'Name',
      between: 'between',
      at: 'at',
      availableDates: {
        title: 'Pick a time for your booking',
        description: 'Choose a new date and time for your appointment',
        emptyTimes: 'No available times',
        noAvailableDates: 'No available slots between {start} and {end}. Please pick another time or contact support.',
        selectAnotherDate: 'Change time',
        selectedDate: 'Booked for',
      },
      confirmationData: 'Confirmation data',
      sendRejectedEmailModal: {
        title: 'Send rejected warning email',
        unableToSendEmail: `Can't send rejection email for the following appointments:`,
        unableToSendEmailTip: 'Please note that to send the rejection email, the appointment must be in the following status: Rejected.',
        sendEmailMessage: 'You are about to send rejection e-mail to {quantity} appointment(s).',
        sendEmailMessageSingle: 'You are about to send rejection e-mail of this appointment.',
        successfullySent: 'Appointment(s) rejection(s) sent with success',
        error: 'An error occurred while sending appointments rejections. Try again later',
        cancel: 'Cancel',
        send: 'Send',
      },
      sendEmailModal: {
        title: 'Send confirmation email',
        unableToSendEmail: `Can't send confirmation email for the following appointments:`,
        unableToSendEmailTip: 'Please note that to send the confirmation email, the appointment must have a tenant assigned, and be in one of the following statuses: Open, Scheduled, Draft or Rejected.',
        sendEmailMessage: 'You are about to send confirmation e-mail to {quantity} appointment(s).',
        sendEmailMessageSingle: 'You are about to send confirmation e-mail of this appointment.',
        successfullySent: 'Appointment(s) confirmation(s) sent with success',
        error: 'An error occurred while sending appointments confirmations. Try again later',
        cancel: 'Cancel',
        send: 'Send',
      },
      rescheduleModal: {
        title: 'Reschedule appointment',
        cancel: 'Cancel',
        reschedule: 'Reschedule',
        rescheduleMessage: 'Please select a new date and time for the appointments',
        rescheduleWarningMessage: 'You are about to reschedule {quantity} appointment(s):',
        date: 'Date',
      },
      form: {
        no: 'No',
        yes: 'Yes',
        name: 'Name',
        email: 'Email',
        tenant: 'Tenant',
        observation: 'Observation',
        commentExplanation: 'Leave a comment describing the reason for not accepting the appointment in the field below.',
        acceptAppointment: 'Accept Appointment',
        accept: 'Accept',
        notAccept: 'Not Accept',
        signature: 'Signature',
        clearSignature: 'Clear Signature',
        confirmAppointment: 'Do you confirm the inspection?',
        attendingToAppointment: 'Will you attend the appointment?',
        keysNeedsAuthorization: 'Do we need to pick up keys?',
        signatureExplanation: 'Use the mouse cursor or your finger, if you are using a mobile device, to sign in the field below.',
        keyAccessNotice: 'Please do not leave key requests on this form. If key access is required, please email us separately. Key access is not available for all inspections and will be assessed on a case-by-case basis.',
        acceptQuestion: 'Do you agree to sign the appointment?',
        submit: 'Submit',
        term: {
          title: 'Terms and conditions:',
          agreeWithTerms: 'I acknowledge and grant consent to access with keys to our property for a routine inspection',
          text: '- Purpose: The access is for the routine inspection on behalf of {branchName} \n- Date and Time: Access is permitted on {date} \n- Notification: I received the required notice via email \n- Key Handling: The key will be provided by {scheduledBy} (Subject to availability) \n- Inspector: {inspector}',
        },
        sentAt: 'Sent at',
        acceptedDate: 'Accepted Date',
        answeredAt: 'Answered At',
      },
      messages: {
        success: 'Confirmation data successfully sent',
        error: 'Error sending confirmation data',
        done: 'Inspection confirmed successfully',
        open: 'Awainting host confirmation',
        scheduled: 'Inspection scheduled',
        canceled: 'Inspection canceled',
        signatureError: 'Error saving the signature, please try again',
        invalidStatus: 'This confirmation link expired or is invalid',
        adminOrPartnerAnswerConfirmationWarning: 'You are logged in as an administrator. To view the tenant version',
        clickHere: 'click here',
        alreadyConfirmed: 'This inspection has already been confirmed for {datetime}',
        alreadyRejected: 'This inspection has already been rejected',
        morning: '08AM and 12PM',
        afternoon: '12PM and 6PM',
        notAnsweredYet: 'The confirmation has not been answered yet',
        noCommentWarning: 'Please add a comment describing the reason to reject the inspection',
        notAttendingOrKeysWarning: 'To confirm the appointment, please either attend in person or authorize key pickup',
        notAttendingWarning: 'To confirm the appointment, please attend in person',
      },
    },
    group: {
      button: {
        create: 'Create group',
      },
      message: {
        createTip: 'To create a group, select only appointments with statuses: Awaiting Host, Rejected, Draft, or Awaiting confirmation',
      },
      hostModal: {
        currentHost: 'Current host',
        changeHost: 'Change host',
        addHost: 'Add host',
        removeHost: 'Remove host',
        changeHostWarningMessage: 'The host should be different from the current',
        host: 'Host',
        removeHostWarningMessage: 'Do you want to remove this host from the group?',
        confirm: 'Confirm',
      },
    },
    additionalData: {
      modalTitle: 'Custom fields',
      fields: 'Fields',
      type: 'Type',
      title: 'Title',
      value: 'Value',
      edit: 'Edit',
      remove: 'Remove',
      add: 'Add field',
      noAdditionalData: 'No custom fields',
      types: {
        PHONE: 'Phone',
        OTHER: 'Other',
        LINK: 'Link',
        EMAIL: 'Email',
      },
      modal: {
        title: 'Custom fields',
        cancel: 'Cancel',
        submit: 'Submit custom fields',
        confirm: 'Confirm',
        confirmToClose: 'Are you sure you want to close the window? All unsaved data will be lost.',
        confirmToCloseTitle: 'Confirmation',
      },
      errors: {
        fillAllFields: 'Fill in all fields',
      },
    },
    changeStatusModal: {
      title: 'Change status',
      change: 'Change',
      cancel: 'Cancel',
      unableToChangeStatus: 'It is not possible to change the status of the following appointment(s):',
      changeStatusMessage: 'You are about to change the status of {quantity} appointment(s).',
      successfullyChanged: 'Appointment status successfully changed',
      error: 'An error occurred while changing the appointment status. Please try again later',
    },
    workerType: {
      HOST: 'Host',
      INTERNAL: 'Internal team',
      THIRD_PARTY: 'Third party',
    },
  },
  serviceReport: {
    label: {
      serviceReport: 'Service Report',
      itemName: 'Item Name',
      itemDescription: 'Item Description',
      quantity: 'Quantity',
      serviceDescription: 'Service Description',
      location: 'Location',
      category: 'Category',
      items: 'Items',
      quote: 'Quote',
      noServiceReport: 'No reported discrepancies in this service',
    },
  },
  customer: {
    label: {
      name: 'Name',
      document: `Driver's license`,
      actions: 'Actions',
      linked: 'Linked',
      notLinked: 'Not linked',
      useCustomWorkerType: 'Only internal inspectors',
      createLink: 'Create Asaas account link',
      removeLink: 'Remove Asaas account link',
      linkCustomer: 'Link customer',
      linkCustomerType: 'Link customer type',
      removeLinkCustomerType: 'Remove customer type link',
      removeLinkCustomer: 'Remove link',
      linkServiceProvider: 'Link service provider',
      unlinkServiceProvider: 'Unlink service provider',
      removeLinkServiceProvider: 'Remove service provider link',
      selectedCustomer: 'Selected customer',
      selectedAsaasCustomer: 'Selected ASAAS customer',
      selectCustomer: 'Select customer',
      serviceType: 'Service type',
      visualizeContracts: 'View Contracts',
      newContract: 'New Contract',
      save: 'Save',
      code: 'Code',
      linkVendors: 'Link Vendors',
      vendors: 'Vendors',
      edit: 'Edit',
      showBranches: 'Show branches',
      addBalance: 'Add balance',
      details: 'Customer details',
      monetary: 'Monetary',
      selectAServiceProvider: 'Select a service provider',
      selectedServiceProvider: 'Selected service provider',
      search: 'Search',
      searchCustomer: 'Search customer',
      noData: 'No results. Use the search field',
      support: 'Customer support',
    },
    create: {
      name: 'Name',
      cnpj: 'CNPJ',
      document: `Driver's license`,
      logo: 'Logo',
      city: 'City',
      email: 'Email',
      phone: 'Phone',
      informations: 'Information',
      sendToNomah: 'Send to Nomah',
      tester: 'Test user',
      useCustomWorkerType: 'Use only internal inspectors',
      appointmentResumeContact: 'Email for appointment result',
      sendEmailConfirmationCopy: 'Send confirmation email copy',
      sendEmailToEscort: 'Notify companions, visitors, or tenants',
      useCancelationLimit: 'Use cancellation advance limit',
      cancelationLimitHours: 'Cancellation limit time',
      usesCustomFeedback: 'Use custom feedback',
      feedbackURL: 'Feedback URL',
      devolusEnabled: 'Enable Devolus',
      devolusToken: 'Devolus Token',
      devolusId: 'Devolus ID',
      devolusWebhookUrl: 'Devolus webhook URL',
      addDefaultContract: 'Apply Default Contract',
      subscriptionType: 'Subscription Types',
      services: 'Service Types',
      realEstateUser: 'Real estate user',
      devolus: 'Devolus',
      cpf: 'Driver License Number',
      hour: 'hour',
      hours: 'hours',
      headquarter: 'Headquarter',
      negativeBalanceLimit: 'Negative balance limit',
      disputeCreationDaysLimit: 'Dispute deadline (business days)',
      disputeCreationDaysLimitHint: 'Leave empty to use the default of 11 business days',
      messages: {
        successCreation: 'Customer created successfully',
        successUpdate: 'Customer updated successfully',
      },
      startDate: 'Start date',
      monthlyCapacity: 'Monthly volume (Capacity)',
      dailyCapacity: 'Daily volume (Capacity)',
      dailyCapacityError: 'Monthly volume must be greater than or equal to 0',
      valueError: 'Monthly value must be greater than or equal to 0',
      priceCapacityError: 'Price must be greater than or equal to 0',
      priceSquareMeterError: 'Price per m² must be greater than or equal to 0',
      baseSquareMetersSizeError: 'Base size must be greater than or equal to 0',
      taxForSquareMeters: 'Rate per m² must be between 0 and 100%',
      currency: 'Currency',
      feedback: 'Feedback',
      contract: 'Contract',
      allowKeyPickup: 'Allows key pickup',
      allowsPeriodAppointment: 'Allows appointments by period',
      allowsEndTimeAppointment: 'Allows appointments with end time',
      removePartner: 'Remove partner',
      serviceDurationValidationType: {
        label: 'Schedule overlap validation',
        options: {
          default: 'Default',
          strictDuration: 'Do not allow overlap (considers service duration)',
        },
      },
    },
    branches: {
      label: {
        name: 'Name',
        address: 'Address',
        city: 'City',
        cnpj: 'CNPJ',
        phone: 'Phone',
        email: 'Email',
        resumeContact: 'Email for sending appointment summaries',
        isHeadquarter: 'Headquarter',
      },
      hint: {
        headquarterCannotBeDeleted: 'The headquarter branch cannot be deleted',
        headquarterManagedExternally: 'The headquarter is managed by Hauseful Checklist and cannot be edited here',
      },
      modals: {
        form: {
          createTitle: 'Create new branch',
          updateTitle: 'Edit branch',
        },
        confirmDelete: {
          title: 'Confirm',
          text: 'Are you sure you want to delete the branch?',
          usersMigrateToHeadquarter:
            'The users of this branch will be moved to the headquarter branch.',
          buttons: {
            cancel: 'Cancel',
            confirm: 'Confirm',
          },
        },
      },
      messages: {
        successDelete: 'Branch removed successfully',
        successUpdate: 'Branch updated successfully',
        successCreation: 'Branch created successfully',
      },
      actions: {
        create: 'New branch',
        edit: 'Edit',
        delete: 'Delete',
      },
      sendEmailConfirmationCopy: 'Send confirmation email copy',
    },
  },
  movement: {
    actions: {
      movementExcel: {
        generateExcel: 'Generate Excel',
        fileName: 'balance_report',
        generateExcelGroupedByBranch: 'Generate Excel - grouped by branch',
        fileNameGroupedByBranch: 'balance_report_grouped',
      },
    },
    label: {
      createdAt: 'Created at',
      description: 'Description',
      total: 'Total',
      movement: 'Movement',
      appointment: 'Appointment',
      realtiesQuantity: 'Number of properties',
      pricePerRealty: 'Price per property',
      discount: 'Discount',
      balance: 'Current balance',
      available: 'Available',
      committed: 'Committed',
      customerBalance: 'Current customer balance',
      showAppointment: 'View appointment',
      movementReport: 'Balance report',
      movementReportByBranch: 'Balance report by branch',
      changeBalance: 'Change balance',
      category: 'Category',
      reason: 'Reason',
      customer: 'Customer',
      comment: 'Comment',
      rechargeNote: 'Recharge note',
    },
    category: {
      REFUND: 'Refund',
      RECHARGE: 'Recharge',
      TERMINATION: 'Termination',
      TRANSFER: 'Transfer',
      CHARGE: 'Charges',
      RENT_OUT: 'Rentout',
      POST_PAID: 'Post-paid',
      EXPENDITURE: 'Consumption',
    },
    reason: {
      DAMAGES_AND_LOSSES: 'Damages and losses',
      MISSING_ACCEPTANCE: 'Lack of acceptance',
      CREDIT_ADVANCE: 'Credit advance',
      CREDIT_CORRECTION: 'Credit correction',
      CREDIT_ADDITION: 'Credit addition',
      CONTRACTUAL_PENALTY: 'Contractual penalty',
      EXPIRED_BALANCE: 'Expired balance',
      BALANCE_TRANSFER_BETWEEN_ACCOUNTS: 'Balance transfer between accounts',
      EXPIRED_CHARGE: 'Expired charge',
      RECEIVED_CHARGE: 'Received charge',
      COMISSION_PAYMENT: 'Commission payment',
      FCI_PAYMENT: 'FCI payment',
      APPOINTMENT_DONE: 'Appointment done',
      APPOINTMENT_NOT_DONE: 'Appointment not done',
      RECALCULATION: 'Recalculation',
      BALANCE_PAYMENT: 'Payment with balance',
      PLATFORM_FEE: 'Platform fee',
      SAAS_SUBSCRIPTION: 'Saas subscription',
      OVERUSE_FEE: 'Overuse fee',
    },
    filters: {
      noData: 'No results',
      document: 'document',
      sort: 'Sort',
      period: 'Period',
      selectDate: 'Select a date',
      sortBy: {
        ASC: 'Oldest',
        DESC: 'Most recent',
      },
      buttons: {
        reset: 'Clear',
        applyFilters: 'Apply filters',
      },
      datePicker: {
        selectedItems: '2 selected',
      },
    },
    table: {
      loading: 'Loading... Please wait',
      noData: 'No results',
      showExtraFields: 'Show extra fields',
    },
    create: {
      value: 'Value',
      cancel: 'Cancel',
      description: 'Description',
      modalTitle: 'Add balance',
      availableBalance: 'Current balance',
      confirmButton: 'Confirm',
      sendTo: 'Send to',
      messages: {
        balanceAdded: 'Value of {value} added successfully',
        balanceRemoved: 'Value of {value} removed successfully',
      },
    },
    messages: {
      selectAClientToAccessMovements: 'Select a client to access the movements',
      balanceAvailableForUse: 'Balance available for use',
      valueAlreadyCommittedToOpenAppointments: 'Value already committed for open appointments',
    },
  },
  realty: {
    label: {
      type: 'Type',
      code: 'Code',
      city: 'City',
      address: 'Address',
      description: 'Description',
      externalSource: 'Source',
      additionalAddressData: 'Additional',
      postalCode: 'Postal Code',
      squareMeters: 'Square Meters',
      privateArea: 'Private Area',
      totalArea: 'Total Area',
      gallery: 'Photo Gallery',
      place: 'Place',
      meters: 'Measurement',
      photos: 'Photos',
      trousseau: 'Linen',
      furniture: 'Furniture',
      paintingStatus: 'Painting Status',
      updateRealty: 'Update Realty',
      details: 'Details',
      privateAreaMetersShort: 'm² Private',
      squareMetersShort: 'm² Total',
      theRealtyContains: 'The realty contains:',
      doesNotHavePhotos: 'This property does not have photos',
      doesNotHaveVideos: 'This property does not have videos',
      videoUrl: 'Video link (YouTube or Vimeo)',
      addVideo: 'Add',
      videoWithoutTitle: 'Untitled video',
      videoTitle: 'Video name (optional)',
      unsupportedVideoUrl: 'The link must be from YouTube or Vimeo',
      addClickingBelow: 'Add clicking below',
    },
    type: {
      APARTMENT: 'Apartment',
      HOUSE: 'House',
      PENTHOUSE: 'Penthouse',
      GARAGE: 'Garage',
      COMERCIAL: 'Commercial Properties',
      KITNET: 'Kitnet',
      LOFT: 'Loft',
      TWO_STORY_HOUSE: 'Two-story House',
      LOT: 'Lot',
      STUDIO: 'Studio',
    },
    warnings: {
      cityFarFromRealEstate: 'Property city is different from your operating city',
      withoutPrivateArea: "Provide the property's private area to continue",
      realtyNotAvailable: 'Property not available at the chosen time and date',
      codeExistsAlready: 'Code already exists, add another',
      furnishedNull: 'Property has no information about furniture',
      trousseauNull: 'Property has no information about linen',
      paintingNull: 'Property has no information about painting status',
      withoutType: 'Property has no type (apartment, house, penthouse, etc.)',
      noRouteFound: 'Street not found (Mandatory)',
      noPostalCodeFound: 'Postal code not found',
      noStreetNumberFound: 'Number not found',
      noVicinityFound: 'Unidentified neighborhood',
    },
    success: {
      realtyCreated: 'Realty created successfully',
      realtyUpdated: 'Realty updated successfully',
      realtyRemoved: 'Realty removed successfully',
      realtyDetailsUpdated: 'Realty details updated',
    },
    buttons: {
      add: 'Add Realty',
      save: 'Save',
      selectPhotos: 'Select Photos',
      reset: 'Reset',
    },
    filters: {
      noData: 'No results',
      search: 'Search',
      city: 'City',
      buttons: {
        reset: 'Reset',
        applyFilters: 'Apply Filters',
      },
    },
    table: {
      loading: 'Loading... Please wait',
      noData: 'No results',
    },
    toaster: {
      success: {
        updated: 'Realty updated successfully!',
        created: 'Realty created successfully!',
      },
    },
    paintingStatus: {
      NEW: 'New',
      WORN: 'Worn',
      HOST_CRITERIA: "At the Host's discretion",
    },
    furnishing: {
      NOT_FURNISHED: 'Unfurnished',
      SEMI_FURNISHED: 'Semi-furnished',
      FURNISHED: 'Furnished',
    },
    formCreate: {
      titles: {
        details: 'Details',
        location: 'Location',
        vista: 'Loft data',
      },
      vista: {
        categoria: 'Loft category',
        categoriaRequired: 'Loft category *',
        finalidade: 'Loft purpose *',
        situacao: 'Loft condition *',
        ocupacao: 'Loft occupancy *',
        status: 'Loft status *',
      },
      code: 'Code *',
      codePlaceholder: 'Enter a code for the property',
      description: 'Description',
      descriptionPlaceholder: 'Enter a description for the property',
      paintingStatus: 'Painting Status *',
      paintingStatusPlaceholder: "Select the property's painting status",
      furnished: 'Furniture',
      trousseau: 'Linen',
      totalArea: 'Total Area *',
      totalAreaPlaceholder: 'Enter the total area of the property',
      privateArea: 'Private Area *',
      privateAreaPlaceholder: "Enter the property's private area",
      addressComplement: 'Additional Address',
      realtyType: 'Property Type *',
      rentValue: 'Rental Value',
      sellValue: 'Selling Value',
      realEstate: 'Real estate',
    },
    hint: {
      editWarning: 'Modifying this information will impact the value of related schedules',
      codeFromVista: 'Code generated by Loft, not editable',
      vistaFields: 'Fields required by Loft, they do not exist in Hauseful. Sent only when the property is created.',
      vistaCategoria: 'Optional: Loft derives the category from the property type. Required for type "Other".',
      seeOnMaps: 'View on Maps',
      addressExemple: '123 Eagle St, Brisbane City QLD 4000, Australia',
    },
  },
  realEstateUsers: {
    table: {
      name: 'Name',
      username: 'Email',
      is_tester: 'Tester',
      status: 'Active',
      type: 'Type',
    },
    label: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      details: 'Details',
      branch: 'Branch',
      role: 'Position',
      password: 'Password',
      address: 'Address',
      realEstate: 'Real Estate',
      loading: 'Loading...',
      repeatPassword: 'Repeat Password',
      isTester: 'Test User',
      isActive: 'Active User',
      edit: 'Edit User',
      create: 'Create User',
      remove: 'Remove User',
      cancel: 'Cancel',
      newUser: 'New User',
      cpf: 'Driver License Number',
      rg: 'ID',
    },
    hint: {
      onlyNumbers: 'Only numbers',
      deleteUser: 'Do you want to remove this user',
    },
    isTester: {
      true: 'Test User',
      false: 'Not a test user',
    },
    isActive: {
      true: 'Active User',
      false: 'Inactive User',
    },
    actions: {
      show: 'View',
      edit: 'Edit',
      exclude: 'Delete',
    },
  },
  boolean: {
    true: 'Yes',
    false: 'No',
    undefined: 'Not defined',
  },
  report: {
    types: {
      appointment: 'Appointments Report',
      appointmentWithQuestionnaire: 'Appointments Report with Questionnaire Information',
      appointmentQuantity: 'Number of Appointments Report',
    },
    groupingTypes: {
      day: 'Day',
      week: 'Week',
      month: 'Month',
    },
    dateSorts: {
      scheduled: 'Scheduled',
      creation: 'Creation',
    },
    buttons: {
      generate: 'Generate',
      reset: 'Reset',
    },
    filters: {
      type: 'Type',
      grouping: 'Grouping',
      groupRealties: 'Group properties?',
      date: 'Date',
      period: 'Period',
      noData: 'No results',
      status: 'Status',
      city: 'City',
      branch: 'Branch',
      datePicker: {
        selectedItems: '2 selected',
      },
    },
    toaster: {
      success: {
        created: 'Report generated successfully!',
      },
    },
    table: {
      noData: 'No results',
    },
  },
  city: {
    label: {
      city: 'City',
      cities: 'Cities',
      status: 'Status',
      name: 'Name',
      state: 'State',
      services: 'Services',
      enabled: 'Enabled',
      disabled: 'Disabled',
    },
    hint: {
      search: 'Search for a city name',
    },
    noData: 'No results. Search for a city name.',
  },
  deleteModal: {
    warning: 'Attention',
    warningMessage: "Are you sure you want to remove '{entityName}'?",
    wantToUnlink: 'Do you want to unlink <strong>{type}</strong>?',
    buttons: {
      delete: 'Delete',
      cancel: 'Cancel',
      deleteFile: 'Delete file',
      deleteAllFiles: 'Delete all files',
      deleteSelectedFiles: 'Delete selected files',
    },
    toaster: {
      success: {
        deleted: "'{entityName}' successfully deleted!",
      },
    },
  },
  inactiveModal: {
    title: 'Deactivate',
    warning: 'This action is irreversible',
    question: 'Do you really want to deactivate this item?',
    buttons: {
      inactivate: 'Deactivate',
      cancel: 'Cancel',
    },
  },
  defaultContract: {
    useOldContractServices: 'Use services from the old contract',
  },
  detailsModal: {
    title: 'Details',
    moreDetails: 'More details',
  },
  hostOnboarding: {
    types: {
      REGISTRATION: 'Registration',
      COURSE: 'Course',
      TALK: 'Talk',
      AGREEMENT: 'Agreement',
      DONE: 'Done',
      DISAPPROVED: 'Disapproved',
      TEORIC_TEST: 'Theoretical Test',
      TEST_SERVICE: 'Test Service',
    },
    disapproveTypes: {
      BACKGROUND_CHECK_SCORE: 'Poor background check score',
      ENGAGEMENT: 'Low engagement in the process',
      BEHAVIOR: 'Inappropriate behavior during the process',
      COURSE_TIME: 'Did not finish the course on time',
      EQUIPMENT: 'Did not purchase the necessary equipment',
      AGREEMENT_ASSIGNMENT: 'Did not sign the contract',
      PERMANENT: 'Permanent',
      OTHER: 'Other',
    },
    coursePercentage: {
      NOT_STARTED: 'Not started',
      TWENTY: '20%',
      FORTY: '40%',
      SIXTY: '60%',
      EIGHTY: '80%',
      FINISHED: 'Finished',
    },
    label: {
      name: 'Name',
      description: 'Description',
      link: 'Link',
      course: 'Course',
      progress: 'Progress',
      feedbacks: 'Comments',
      attachments: 'Attachments',
    },
    warnings: {
      backgroundCheckNotStarted: "Host's personal background check not yet performed",
      backgroundCheckInProgress: "Host's personal background check is in progress",
      backgroundCheckBadScore: 'Host has a lower than expected score',
    },
    actions: {
      cancel: 'Cancel',
      confirm: 'Confirm',
    },
  },
  defaultServiceValues: {
    cityAndContractType: 'City and contract type',
    type: 'Type',
    values: 'Values',
    taxes: 'Taxes',
    defaultServiceValuesDetails: 'Details and values',
    label: {
      serviceType: 'Service Type',
      contractType: 'Contract Type',
      contract: 'Contract',
      noService: 'No service found',
      city: 'City',
      status: 'Status',
      name: 'Service Name',
      dateCreated: 'Creation Date',
      createdBy: 'Creator',
      price: 'Price',
      discount: 'Discount',
      squareMetersPrice: 'Price per m²',
      baseSquareMetersPrice: 'Base size m²',
      taxHost: 'Host Tax',
      displacementTax: 'Bonus Tax',
      taxSquareMeters: 'Tax per m²',
      furnitureTax: 'Furniture Tax',
      semiFurnitureTax: 'Semi-furnished Tax',
      houseTax: 'House Tax',
      trousseauTax: 'Trousseau Tax',
      active: 'Active',
      inactive: 'Inactive',
      actions: 'Actions',
      hostRealtyFeatureTax: 'Host taxes on property feature values',
      urgencyTax: 'Urgency Tax',
      urgencyHoursLimit: 'Urgency limit in hours',
      hostRealtyFeatureTax: 'Host tax on urgency',
    },
    hints: {
      cityAndContractType: 'Choose the contract type and city. If no city is selected, the values will be added as default for all cities.',
    },
    filters: {
      paymentType: 'Payment Type',
    },
    isActive: {
      true: 'Payment active',
      false: 'Payment inactive',
    },
    actions: {
      add: 'Add',
      create: 'Create new default value',
      cancel: 'Cancel',
      update: 'Update',
      inactivate: 'Deactivate',
      visualize: 'View',
      continueWithoutCity: 'Continue without city',
      continueWithSelectedCity: 'Continue with selected city',
    },
    messages: {
      serviceAlreadySelected: 'Service already selected',
      successfullyCreated: 'Default value created successfully',
      errorWhileCreating: 'Error while creating default value',
    },
  },
  create: {
    integrationRequest: {
      externalSource: 'Source',
      apiUrl: 'URL',
      keyCode: 'Key',
    },
    label: {
      host: 'New Host',
      appointment: 'New Appointment',
      realty: 'New Property',
      recharge: 'New Recharge',
      defaultServiceValues: 'New default value',
      addCustomContract: 'New contract',
      mission: 'New Mission',
      integration: 'New Integration',
      newUser: 'New user',
      questionnaire: 'New questionnaire',
      transfer: 'New transfer',
      customer: 'New customer',
      announcement: 'New announcement',
      customerBranch: 'New branch',
    },
    actionMenu: {
      host: 'Host',
      appointment: 'Appointment',
      realty: 'Property',
      recharge: 'Recharge',
      defaultServiceValues: 'default value',
      mission: 'New Mission',
      integration: 'Integration',
      newUser: 'User',
    },
    save: 'Save',
    update: 'Update',
    cancel: 'Cancel',
    refund: 'Refund payment',
    generateSinglePayment: 'Generate single payment',
    generateCalculatedPayment: 'Generate calculated payment',
  },
  update: {
    integrationRequest: {
      externalSource: 'Source',
      apiUrl: 'URL',
      keyCode: 'Key',
    },
  },
  auth: {
    token: 'Token',
    verify: 'Verify',
    title: 'We are Hauseful',
    welcome: 'Welcome. Please log in.',
    username: 'User',
    password: 'Password',
    login: 'Log in',
    logout: 'Log out of system',
    send: 'Send email',
    forgotPassword: 'Forgot your password?',
    recoverPassword: 'Recover password',
    update: 'Update password',
    email: 'Email',
    back: 'Back',
    resetPassword: 'Reset password',
    goBackToLogin: 'Back to login',
    success: {
      resetPassword: 'Password reset successfully',
      recoverPasswordEmailSent: 'Email sent successfully',
      recoverPasswordEmailSentDescription: 'Check your email for instructions on how to reset your password.',
    },
    errors: {
      recoverTokens: 'Error retrieving tokens',
      retrieveToken: 'Error retrieving tokens',
      requiredToken: 'Token is required',
      invalidToken: 'Invalid token',
      login: 'Invalid username or password',
      userWithoutRole: 'No role found for the user',
      expiredSession: 'Your session has expired',
      errorGeneratingPdf: 'Error generating pdf file',
    },
    autoLogin: {
      signingIn: 'Signing you in…',
    },
  },
  status: {
    OPEN: 'Awaiting Host',
    SCHEDULED: 'Scheduled',
    DONE: 'Done',
    CANCELED: 'Cancelled',
    PENDING: 'Pending Actions',
    DRAFT: 'Draft',
    REJECTED: 'Rejected',
    PARTNER_OPEN: 'Open',
  },
  type: {
    VISIT: 'Visit',
    VISIT_PREMIUM: 'Premium Visit',
    PHOTOGRAPHY: 'Photography',
    PHOTOGRAPHY_PREMIUM: 'Premium Photography',
    PHOTOGRAPHY_360: '360° Photography',
    KEY_DELIVERY: 'Key Delivery',
    INSPECTION: 'Gold Entry Inspection',
    DISPLACEMENT: 'Bonus',
    DRONE: 'Drone',
    LOFT_VISIT: 'Loft Visit',
    INSPECTION_ENTRANCE: 'Entry Inspection',
    INSPECTION_ENTRANCE_PREMIUM: 'Premium Entry Inspection',
    INSPECTION_EXIT: 'Exit Inspection',
    INSPECTION_EXIT_GOLD: 'Gold Exit Inspection',
    INSPECTION_EXIT_PREMIUM: 'Premium Exit Inspection',
    INSPECTION_INTERMEDIARY: 'Intermediate Work Inspection',
    INSPECTION_DELIVERY: 'Work Delivery Inspection',
    INSPECTION_MEASUREMENT: 'Measurement Inspection',
    INSPECTION_AUDITANCE: 'Audit Inspection',
    REINSPECTION: 'Re-inspection',
    REINSPECTION_HAUSEFUL: 'Re-inspection Hauseful',
    TECHNICAL_SKETCH: 'Premium 2D Survey',
    TECHNICAL_SKETCH_PLUS: '2D Plus Survey',
    PLANNING: 'Projects',
    IMAGE_EDITING: 'Image Editing',
    REALTY_SUGGESTION: 'Property Suggestion',
    REMOTE_VISIT: 'Remote Visit',
    SKETCH: '3D Survey',
    INSPECTION_ENTRANCE_PLUS: 'Entry Inspection Plus',
    INSPECTION_EXIT_PLUS: 'Exit Inspection Plus',
    INSPECTION_MINI: 'Mini Entry Inspection',
    VISIT_GOLD: 'Gold Visit',
    INSPECTION_CONSTRUCTION_INTERMEDIARY: 'Construction Oversight - Intermediate',
    INSPECTION_CONSTRUCTION_FINAL: 'Construction Oversight - Final',
    INSPECTION_CONFERRING_ENTRANCE: 'Entry Inspection - Conference',
    INSPECTION_ENTRANCE_HOUSEVIEW: 'Entry Inspection - Houseview',
    INSPECTION_EXIT_HOUSEVIEW: 'Exit Inspection - Houseview',
    MAPPING_FOR_EVALUATION: 'Information Mapping',
    TERMINATION: 'Termination',
    RENT_OUT: 'Facilitated Termination',
    RENT_OUT_DUDA: 'Facilitated Termination - Duda Real Estate',
    DELIVERY: 'Delivery',
    INSPECTION_POST_INSTALLATION: 'Installation Inspection',
    INSPECTION_AND_ESTIMATE: 'Inspection + Budget',
    INSPECTION_SHED: 'Shed Inspection - Entrance',
    INSPECTION_SHED_EXIT: 'Shed Inspection - Exit',
    INSPECTION_IMOBMIX_ENTRANCE: 'IMOBMIX Inspection - Entrance',
    INSPECTION_IMOBMIX_EXIT: 'IMOBMIX Inspection - Exit',
    PHOTOGRAPHY_PLUS: 'Photography Plus',
    PHOTOGRAPHY_HAUSEFUL: 'Hauseful Photography',
    PHOTOGRAPHY_HOME_STAGING: 'Gold Photography',
    VISIT_AND_PHOTOS: 'Visit + Photography',
    VISIT_LIGHT: 'Light Visit',
    VISIT_SALE: 'Sales Visit',
    TRAINING: 'Practical Training',
    MISSION: 'Missions',
    PHOTOGRAPHY_PREMIUM_PLUS_360: 'Premium Photography + 360',
    OBSERVED_TRAINING: 'Observed Training',
    DUMP: 'Abandonment Determination',
    EVICTION: 'Viewing - Keys',
    INSPECTION_TEST: 'Test Inspection',
    INSPECTION_IB_ENTRANCE: 'IB Entry Inspection',
    INSPECTION_IB_EXIT: 'IB Exit Inspection',
    INSPECTION_MINI_EXIT: 'Mini Exit Inspection',
    INSPECTION_MINI_EXIT_GOLD: 'Mini Gold Exit Inspection',
    INSPECTION_MINI_EXIT_PLUS: 'Mini Exit Plus Inspection',
    INSPECTION_MINI_ENTRANCE_GOLD: 'Mini Gold Entry Inspection',
    INSPECTION_MINI_ENTRANCE_PLUS: 'Mini Entry Plus Inspection',
    INSPECTION_ENTRANCE_BACKLOG: 'Entry Inspection - Backlog',
    INSPECTION_EXIT_BACKLOG: 'Exit Inspection - Backlog',
    INSPECTION_ENTRANCE_ANTICIPATION: 'Entry Inspection - Anticipation',
    INSPECTION_INSURER: 'Insurance Determination Inspection',
    INSPECTION_ENTRANCE_GOLD_ONE_OFF: 'Entrance inspection Gold - One-off',
    INSPECTION_EXIT_GOLD_ONE_OFF: 'Checkout inspection Gold - One-off',
    LEASED_PROPERTY_CONFERENCE_ENTRANCE: 'Rented Property Conference - Entry',
    LEASED_PROPERTY_CONFERENCE_INTERMEDIARY: 'Rented Property Conference - Intermediate',
    LEASED_PROPERTY_CONFERENCE_EXIT: 'Rented Property Conference - Exit',
    DEBT_NOTIFICATION: 'Debt Collection',
    PHOTOGRAPHY_PLUS_FOTOP: 'Photography Plus Fotop',
    PHOTOGRAPHY_PREMIUM_FOTOP: 'Premium Photography Fotop',
    ROUTINE_INSPECTION: 'Routine inspection',
    INGOING_INSPECTION: 'Ingoing inspection',
    OUTGOING_INSPECTION: 'Outgoing inspection',
    VIRTUAL_TOUR: 'Virtual tour',
    INGOING_INSPECTION_VIRTUAL_TOUR: 'Ingoing inspection + Virtual tour',
    REVISION_INSPECTION: 'Revision inspection',
    MEASURE_AND_CAPTURE: 'Measure and Capture',
    INGOING_APARTMENT_THREE_BEDS: 'Ingoing - Apartments up to 3 Beds',
    INGOING_APARTMENT_FOUR_PLUS_BEDS: 'Ingoing - Apartments 4 Beds +',
    INGOING_HOUSE_THREE_BEDS: 'Ingoing - House Up to 3 Beds',
    INGOING_HOUSE_FOUR_BEDS: 'Ingoing - House 4 Beds',
    INGOING_HOUSE_FIVE_PLUS_BEDS: 'Ingoing - House 5 Beds +',
    OUTGOING_APARTMENT_THREE_BEDS: 'Outgoing - Apartments up to 3 Beds',
    OUTGOING_APARTMENT_FOUR_PLUS_BEDS: 'Outgoing - Apartments 4 Beds +',
    OUTGOING_HOUSE_THREE_BEDS: 'Outgoing - House Up to 3 Beds',
    OUTGOING_HOUSE_FOUR_BEDS: 'Outgoing - House 4 Beds',
    OUTGOING_HOUSE_FIVE_PLUS_BEDS: 'Outgoing - House 5 Beds +',
    QUESTIONNAIRE: 'Questionnaire',
    GONDOLA: 'Gondola',
    INSPECTION_ENTRANCE_SHORTSTAY: 'Shortstay entrance inspection',
    INSPECTION_EXIT_SHORTSTAY: 'Shortstay exit inspection',
    INGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR: 'Ingoing - Apartments up to 3 Beds and Virtual Tour',
    INGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR: 'Ingoing - Apartments 4 Beds +  and Virtual Tour',
    INGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR: 'Ingoing - House Up to 3 Beds  and Virtual Tour',
    INGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR: 'Ingoing - House 4 Beds  and Virtual Tour',
    INGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR: 'Ingoing - House 5 Beds +  and Virtual Tour',
    OUTGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR: 'Outgoing - Apartments up to 3 Beds  and Virtual Tour',
    OUTGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR: 'Outgoing - Apartments 4 Beds +  and Virtual Tour',
    OUTGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR: 'Outgoing - House Up to 3 Beds  and Virtual Tour',
    OUTGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR: 'Outgoing - House 4 Beds  and Virtual Tour',
    OUTGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR: 'Outgoing - House 5 Beds +  and Virtual Tour',
    HAUSEFUL_ENTRANCE: 'Hauseful entrance inspection',
    HAUSEFUL_EXIT: 'Hauseful exit inspection with comparison',
    HAUSEFUL_EXIT_WITHOUT_COMPARISON: 'Hauseful exit inspection without comparison',
    INSPECTION_ABANDONMENT_HAUSEFUL: 'Abandonment inspection - Hauseful',
    INSPECTION_GIACOMELLI_ENTRANCE: 'Giacomelli inspection - Entrance',
    INSPECTION_GIACOMELLI_EXIT: 'Giacomelli inspection - Exit',
    INSPECTION_PRELIMINARY: 'Precautionary inspection',
    INSPECTION_PRELIMINARY_TYPE_ONE: 'Precautionary inspection - Type 1',
    INSPECTION_PRELIMINARY_TYPE_TWO: 'Precautionary inspection - Type 2',
    INSPECTION_PRELIMINARY_TYPE_THREE: 'Precautionary inspection - Type 3',
    INSPECTION_ENTRANCE_REDEPLAN: 'Entrance Inspection - Redeplan',
    INSPECTION_EXIT_REDEPLAN: 'Exit Inspection - Redeplan',
    INSPECTION_INTERMEDIARY_REDEPLAN: 'Intermediary Inspection - Redeplan',
    INSPECTION_ROUTINE_PLUS_VIRTUAL_TOUR: 'Routine inspection + Virtual Tour',
    INSPECTION_INGOING_STUDIO: 'Ingoing - Studio',
    AIRBNB_CLEANING: 'Airbnb Cleaning',
    HEAVY_CLEANING_POST_CONSTRUCTION: 'Heavy Cleaning Post-Construction',
    HEAVY_CLEANING_POST_CONSTRUCTION: 'Heavy Cleaning Post-Construction',
    INSPECTION_ENTRANCE_BRASILIA_IMOVEIS: 'Brasília Imóveis entrance inspection',
    INSPECTION_EXIT_BRASILIA_IMOVEIS: 'Brasília Imóveis exit inspection',
    REINSPECTION_BRASILIA_IMOVEIS: 'Brasília Imóveis reinspection',
    INSPECTION_ENTRANCE_NEGRAO: 'J. Negrão entrance inspection',
    INSPECTION_EXIT_NEGRAO: 'J. Negrão exit inspection',
    REINSPECTION_NEGRAO: 'J. Negrão reinspection',
    INSPECTION_ENTRANCE_LIGHT: 'Entrance inspection - Light',
    INSPECTION_EXIT_LIGHT_WITH_COMPARISON: 'Exit inspection with comparison - Light',
    INSPECTION_EXIT_LIGHT_WITHOUT_COMPARISON: 'Exit inspection without comparison - Light',
    REINSPECTION_LIGHT: 'Reinspection - Light',
    INSPECTION_ENTRANCE_LAVIERI: 'Entrance inspection - Lavieri',
    INSPECTION_EXIT_LAVIERI: 'Exit inspection - Lavieri',
    REINSPECTION_LAVIERI: 'Reinspection - Lavieri',
    INSPECTION_ENTRANCE_SANTA_ILHA: 'Entrance inspection - Santa Ilha',
    INSPECTION_EXIT_SANTA_ILHA: 'Exit inspection - Santa Ilha',
    REINSPECTION_SANTA_ILHA: 'Reinspection - Santa Ilha',
    INSPECTION_ENTRANCE_DOMINAI: 'Entrance inspection - Dominai',
    INSPECTION_EXIT_DOMINAI: 'Exit inspection - Dominai',
    REINSPECTION_DOMINAI: 'Reinspection - Dominai',
    QUALITY_INSPECTION: 'Quality inspection',
    QUALITY_REINSPECTION: 'Quality reinspection',
    VISIT_CHARLIE: 'Visit - Charlie',
    REPOSSESSION: 'Repossession',
    REGISTRATION_FORM: 'Registration form',
    PROPERTY_CAPTURE: 'Property capture',
    INSPECTION_ENTRANCE_CHARLIE: 'Entrance inspection - Charlie',
    INSPECTION_EXIT_CHARLIE: 'Exit inspection - Charlie',
    REGISTRATION_AUTHORITY_INSPECTION: 'Registration Authority inspection',
    INSPECTION_EXIT_DL_WITH_COMPARISON: 'Exit inspection with comparison (DL)',
    INSPECTION_PRELIMINARY_ROMA: 'Preliminary inspection - Roma',
    INSPECTION_PRELIMINARY_HAUSEFUL: 'Hauseful preliminary inspection',
    INSPECTION_DELIVERY_BUILDER: 'Construction delivery inspection - Builder',
    AGENDA_FORM: 'Agenda form',
    VISIT_IBAGY: 'Visit - Ibagy',
    VISIT_RENASCENCA: 'Visit - Renascença',
    PROPERTY_CAPTURE_RENASCENCA: 'Property capture - Renascença',
    INSPECTION_DELIVERY_STANDARD: 'Construction delivery inspection - Standard',
    INSPECTION_DELIVERY_MEDIUM: 'Construction delivery inspection - Medium',
    INSPECTION_DELIVERY_HIGH_STANDARD: 'Construction delivery inspection - High standard',
    PREVENTIVE_RECORD: 'Preventive record',
    PREVENTIVE_RECORD_TYPE_ONE: 'Preventive record type 1',
    PREVENTIVE_RECORD_TYPE_TWO: 'Preventive record type 2',
    PREVENTIVE_RECORD_TYPE_THREE: 'Preventive record type 3',
    INSPECTION_ROUTINE_REPORT_PROPERFY: 'Properfy - Routine inspection report',
    INSPECTION_NEUTRAL_MODEL_DOMINAI: 'Neutral model - Dominai',
    undefined: 'No selected service',
  },
  paymentTypes: {
    TRIAL: 'Trial',
    PREPAID: 'Prepaid',
    PREPAID_SAAS: 'Prepaid SAAS',
    POSTPAID: 'Postpaid',
    POSTPAID_SAAS: 'Postpaid SAAS',
    SINGLE_PURCHASE: 'Single Purchase',
    SUBSCRIPTION_YEAR: 'Yearly Subscription',
    SUBSCRIPTION_TRIMESTER: 'Quarterly Subscription',
    SUBSCRIPTION_SEMESTER: 'Biannual Subscription',
    SUBSCRIPTION_NONAMESTER: '9 months',
    SUBSCRIPTION_LIFELONG: 'Lifetime Subscription',
  },
  mission: {
    errors: {
      initialDateAfterEndDate: 'Initial date transcends end date',
    },
    confirmPayModal: {
      title: 'Confirm',
      text: 'Are you sure you want to pay the mission in the amount of {price} to the host {email}',
      buttons: {
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
    },
    label: {
      name: 'Name',
      description: 'Description',
      active: 'Active',
      price: 'Prize',
      serviceQuantity: 'Service Quantity',
      tierHost: 'Host Tier',
      startDate: 'Start',
      endDate: 'End',
      hour: 'Hour',
      missionDay: 'Mission Days',
      serviceTypes: 'Service Types',
      cities: 'Cities',
      progressCheck: 'Follow-up',
      hostEmail: 'Host Email',
      hostName: 'Host Name',
      missionProgress: 'Mission Progress',
      updateMission: 'Update Mission',
      serviceCount: 'Services Done',
      successCreation: 'Mission created successfully!',
      successUpdate: 'Mission updated successfully!',
      paymentSuccess: 'Mission successfully paid!',
      paymentId: 'Payment Id',
      actions: 'Actions',
      hosts: 'Hosts',
      createdBy: 'Created by',
    },
    status: {
      true: 'Active Mission',
      false: 'Inactive Mission',
    },
    filters: {
      active: 'Active Only',
      completed: 'Completed',
      inProgress: 'In Progress',
    },
    actions: {
      create: 'New Mission',
      update: 'Update Mission',
      duplicate: 'Duplicate Mission',
      details: 'Show Details',
      progress: 'Show Progress',
      edit: 'Edit Mission',
      pay: 'Pay',
    },
    messages: {
      created: 'Mission created successfully',
      updated: 'Mission updated successfully',
      duplicated: 'Mission duplicated successfully',
    },
  },
  host: {
    files: {
      title: 'Documents',
      empty: 'The host has not sent any documents through the app yet',
      loadError: 'Could not load the host documents',
      category: {
        IDENTITY_DOCUMENT: 'Identity document',
        PROOF_OF_ADDRESS: 'Proof of address',
        CRIMINAL_RECORD: 'Criminal record',
        CERTIFICATE: 'Certificate',
        OTHER: 'Other',
      },
    },
    titles: {
      status: 'Status',
      hostInfo: 'Host details',
      billingData: 'Billing data',
    },
    status: {
      ACTIVE: 'Active',
      BLOCKED: 'Blocked',
      SUSPENDED: 'Suspended',
    },
    message: {
      successfullyUnlinkedAsaasAccount: 'The Asaas account has been successfully unlinked!',
      successfullyLinkedAsaasAccount: 'The Asaas account has been successfully linked!',
      specialtyDeleteConfirm: 'Are you sure you want to remove this specialty?',
      specialtyAlreadyExists: 'There is already a specialty with this name.',
      specialtyDeleted: 'Specialty removed successfully!',
      specialtyCreated: 'Specialty created successfully!',
    },
    label: {
      name: 'Name',
      password: 'Password',
      username: 'Email',
      phone: 'Phone',
      cityId: 'City Id',
      city: 'City',
      cpf: 'Driver License Number',
      rg: 'RG',
      partner: 'Partner',
      serviceProvider: 'Service Provider',
      linked: 'Linked to service provider',
      transaction: 'Transaction',
      serviceType: 'Service Type',
      tester: 'Test Host',
      active: 'Active',
      blocked: 'Blocked',
      suspended: 'Suspended',
      status: 'Status',
      author: 'Author',
      date: 'Date',
      type: 'Type',
      total: 'Total',
      createdAt: 'Created at',
      serviceTypes: 'Service Types',
      onboardingStep: 'Onboarding',
      serviceHistory: 'Service History',
      startedOnboardingTrainingAt: 'Test started on',
      birthDate: 'Birth Date',
      inactivated: 'Inactivated',
      isFavorite: 'Favorite',
      false: 'No',
      true: 'Yes',
      favorite: 'Add as favorite',
      unfavorite: 'Remove as favorite',
      description: 'Description',
      generatePassword: 'Generate password automatically',
      hasPlatformAccess: 'Host has platform access',
      unlinkAsaasAccount: 'Unlink Asaas account',
      linkAsaasAccount: 'Link Asaas account',
      asaasAccount: 'Asaas account',
      linkAsaas: 'Link Asaas Account',
      unlinkAsaas: 'Unlink Asaas Account',
      action: 'Action',
      comment: 'Comment',
      linkChecklist: 'Link with Checklist app',
      integration: 'Integration',
      serviceProviderUser: 'Service Provider User',
      notServiceProviderUser: 'Not Service Provider User',
      asaasLinked: 'Asaas account linked',
      asaasNotLinked: 'Asaas account not linked',
      checklistLinked: 'Checklist app linked',
      checklistNotLinked: 'Checklist app not linked',
      checklistAccount: 'Checklist Account',
      hostSpecialties: 'Host specialties',
      createSpecialty: 'Create Specialty',
      specialties: 'Specialties',
      newSpecialty: 'New Specialty',
      deleteSpecialties: 'Delete Specialties',
      actions: 'Actions',
      confirmDeleteSpecialtyTitle: 'Do you really want to remove this specialty?',
      delete: 'Delete',
      customerName: 'Customer Name',
      customerCnpj: 'Customer CNPJ',
      taxRegime: 'Tax Regime',
      typeToSearchHost: 'Type to search host',
      asaas: {
        walletId: 'Wallet id',
        accountStatus: 'Account status',
        apiKey: 'API Key',
        link: 'Link',
        unlink: 'Unlink',
        unlinkWarning: 'Attention! You are about to unlink the Asaas account of {host}',
        status: {
          APPROVED: 'Approved',
          PRE_APPROVED: 'Pre approved',
          AWAITING_APPROVAL: 'Awaiting approval',
          PENDING: 'Pending',
          REJECTED: 'Rejected',
          REFUSED: 'Refused',
        }
      },
      payments: {
        types: {
          CALCULATED: 'Calculated',
          CUSTOM: 'Custom',
          CHARGEBACK: 'Chargeback',
          DETACHED: 'Detached',
        },
        status: {
          CANCELED: 'Canceled',
          FAILED: 'Failed',
          PENDING: 'Pending',
          PROCESSING: 'Processing',
          COMPLETED: 'Completed',
          null: 'Waiting for transfer',
        },
      },
    },
    controlAccess: {
      title: 'Access Control History',
      platformAccess: 'Platform Access',
      hostHasAccess: 'Host has platform access',
      hostHasNoAccess: 'Host has no platform access',
      blockAccess: 'Block platform access',
      unblockAccess: 'Release platform access',
      servicesAccess: 'Services Access',
      hostReceiveServices: 'Host can receive services',
      hostsCantReceiveServices: "Host can't receive services",
      enableServices: 'Enable services access',
      disableServices: 'Disable services access',
      unsuspendBy: 'Unsuspended by',
      suspendReason: 'Comments about suspension',
      unsuspendReason: 'Comments about unsuspension removal',
      observation: 'Comments',
      cancel: 'Cancel',
      headers: {
        date: 'Date',
        author: 'Author',
        expiredAt: 'Reactivate at',
        action: 'Action',
      },
      form: {
        reason: 'Reason',
        observations: 'Comments',
      },
      singlePayment: {
        title: 'Payment list',
        createSinglePayment: 'Create single payment',
        form: {
          amount: 'Payment amount',
          observations: 'Comments',
        },
      },
      suspensionType: {
        BLOCK: 'Block',
        SUSPENSION: 'Suspension',
      },
    },
    suspensionTypes: {
      ADMIN: 'Administrator',
      BEHAVIOUR: 'Behavior',
      INACTIVITY: 'Inactivity',
      SCORE: 'Score',
      BLOCK: 'Blocked',
      RECYCLE: 'Recycling',
      QUITTING: 'Quitting',
      ONBOARDING: 'Onboarding',
      SUSPENSION: 'Suspension',
    },
    modalUpdate: {
      tabs: {
        info: 'Information',
        history: 'History',
        serviceHistory: 'Service history',
        accessControl: 'Access Control',
        realEstateBlacklist: 'Customers restrictions',
        singlePayment: 'Payments',
      },
    },
    realEstateBlacklist: {
      title: 'Customers restrictions',
      emptyList: 'No restrictions registered for this host',
      addSuccess: 'Restriction(s) successfully added',
      removeSuccess: 'Restriction successfully removed',
      columns: {
        date: 'Date',
        realEstate: 'Real estate',
        blockedBy: 'Blocked by',
        notes: 'Notes',
        action: 'Action',
      },
      addForm: {
        realEstateLabel: 'Select Customers',
        notesLabel: 'Notes (optional)',
        submitButton: 'Add restriction',
      },
      confirmRemove: {
        title: 'Remove restriction',
        message: 'Are you sure you want to remove {name} from this host\'s restrictions?',
        confirm: 'Confirm',
        cancel: 'Cancel',
        tooltip: 'Remove restriction',
      },
    },
    history: {
      title: 'Notes history',
      addObservation: 'Add note',
      cancel: 'Cancel',
      action: {
        PRAISE: 'Praise',
        COMPLAINT: 'Complaint',
        NOTE: 'Note',
        RESTRICTION: 'Restriction',
      },
      error: {
        maxLength: 'Maximum of {maxLength} characters',
      }
    },
  },
  payment: {
    transferMethodPreference: {
      PIX: 'PIX',
      ASAAS: 'Asaas',
    },
    list: {
      label: {
        name: 'Name',
        username: 'Email',
        city: 'City',
        total: 'Total',
      },
      actions: {
        hostInvoices: 'Host invoices',
        createTransfer: 'Generate transfer',
        appointmentsDoneByHost: 'Services performed by host',
        payHost: 'Generate transfer',
        cancel: 'Cancel',
        hostPendingInvoicesReport: 'Generate pending invoice report',
        downloadNote: 'Download invoices',

      },
    },
    type: {
      ASAAS_PIX: 'Pix',
      ASAAS_BOLETO: 'Bank Slip',
      ASAAS_CREDIT_CARD: 'Card',
      VALUELESS: 'F.C.I.',
      BALANCE: 'Balance',
    },
    label: {
      transferMethod: 'Transfer via',
      pixKeyType: 'PIX key type',
      pixKey: 'PIX Key',
      walletId: 'Wallet',
    },
    pixType: {
      CPF: 'Driver License Number',
      CNPJ: 'CNPJ',
      EMAIL: 'Email',
      PHONE: 'Phone',
      EVP: 'Virtual Payment Address',
    },
    createTransfer: {
      label: {
        paymentsId: 'Payments list',
      },
    },
    messages: {
      transferGenerated: 'Payment already in line for transfer',
    },
    orderBy: {
      ASC: 'A-Z',
      DESC: 'Z-A',
    },
    transferMethods: {
      ASAAS_TRANSFER: 'Asaas Account',
      BANK_TRANSFER: 'Bank account',
    },
    filter: {
      orderBy: 'Order (Name)',
      transferMethods: 'Receiving Type',
    },
    hint: {
      addToTransferList: 'Select to add items to transfer list',
    },
  },
  financial: {
    label: {
      status: 'Status',
      payments: 'Payments',
      serviceDone: 'Service Done?',
    },
    updatePayments: {
      label: {
        createCalculated: 'Generate Calculated',
        recalculate: 'Recalculate',
        createChargeback: 'Create Chargeback',
        createSinglePayment: 'Create Single Payment',
        useOriginalContract: 'Use original contract',
      },
      calculated: {
        modalTitle: 'Generate calculated payment',
        markRealty: 'Mark on which real estates the service was done:',
        itemReason: 'Reason',
        description: 'Description',
        changeAdditional: 'I want to redefine the additional charges',
      },
      chargeback: {
        modalTitle: 'Create chargeback for the last payment',
      },
      singlePayment: {
        modalTitle: 'Create Single Payment',
        value: 'Value',
        chargeRealEstate: 'Charge from the real estate',
        description: 'Description',
        customPaymentTax: 'Host Tax',
      },
    },
    payment: {
      label: {
        createdAt: 'Date',
        type: 'Type',
        transferStatus: 'Transfer Status',
        value: 'Value',
        host: 'Host',
        paymentType: {
          CALCULATED: 'Calculated',
          CUSTOM: 'Single Payment',
          CHARGEBACK: 'Chargeback',
          // only trip reimbursements reach the appointment's list as DETACHED
          DETACHED: 'Trip reimbursement',
        },
        status: {
          CANCELED: 'Cancelled',
          FAILED: 'Failed',
          PENDING: 'Pending',
          PROCESSING: 'Processing',
          COMPLETED: 'Completed',
          waitingForGeneration: 'Awaiting generation',
          awaitingTransfer: 'Awaiting transfer',
          transferred: 'Transferred',
        },
      },
    },
    breakdown: {
      show: 'Show breakdown',
      unavailable: 'No breakdown available for this payment',
      realEstate: 'Real estate',
      host: 'Host',
      basePrice: 'Base price',
      discount: 'Discount',
      area: 'Area',
      furniture: 'Furniture',
      semiFurniture: 'Semi-furnished',
      house: 'House',
      trousseau: 'Trousseau',
      urgency: 'Urgency',
      total: 'Total',
      additionals: 'Additionals',
      description: 'Description',
      realEstateTotal: 'Real estate total',
      hostTotal: 'Host total',
      legacySemiFurnished: 'Payment calculated before semi-furnished was split out: if any, it is included in Furniture.',
    },
    messages: {
      singlePaymentSuccess: 'Single payment created successfully',
      chargeBackSuccess: 'Payment chargeback successfully created',
    },
    emptyState: 'Content available only for completed or canceled appointments',
  },
  rules: {
    required: 'Required',
    minValue: 'The field value cannot be less than {value}',
    maxValue: 'The field value cannot be greater than {value}',
    valueRequired: 'Value must be zero or positive',
    cancelationLimitHours: 'The maximum time limit for cancellation is 6 hours',
    disputeCreationDaysLimit: 'Enter a deadline between {min} and {max} business days',
    rg: 'The ID must contain between 6 and 14 digits',
    cpf: 'The Driver License Number must contain 11 digits',
    phone: 'The phone must contain 11 digits (including area code)',
    password: 'The password must contain at least 5 and at most 20 characters',
    email: 'The email must be valid',
    minAmount: 'The minimum is {value}',
    maxAmount: 'The limit is {value}',
    cpfInvalid: 'Invalid Driver License Number',
    cnpjInvalid: 'Invalid CNPJ',
    code: 'Invalid code',
    streetNumber: 'Invalid number',
    phone: 'Invalid phone',
    phoneRequired: 'The phone is required',
    term: 'The term is required for Facilitated Termination',
    attachment: 'An attachment is required for this service',
    postalCode: 'The ZIP code is required',
    length: 'The content must be less than {length} characters',
    cantBeNegative: 'The value cannot be negative',
    cantBeGreaterThan100: 'The value cannot be greater than 100%',
    cantBeZero: 'The value cannot be zero',
    passwordNeedsToBeTheSame: 'The passwords must be the same',
    maxCapacity: 'The maximum capacity is {value}',
  },
  filters: {
    title: 'Filters',
    code: 'Code',
    search: 'Search',
    select: 'Select',
    starred: 'Favorites',
    monitored: 'Monitoring',
    dayOfWeek: 'Day of the week',
    serviceTypes: 'Service Types',
    serviceType: 'Service type',
    myAppointments: 'My Appointments',
    searchByCodeOrAddress: 'Search by code or address',
    searchByUserOrEmail: 'Search by name or email',
    onlyNotConfirmed: 'Only not confirmed',
    dates: 'Dates',
    senders: 'Senders',
    receivers: 'Receivers',
    receiver: 'Receiver',
    host: 'Host',
    hosts: 'Hosts',
    branches: 'Branches',
    customer: 'Customer',
    customers: 'Customers',
    transfer: 'Transfer',
    hasTransfer: 'Has transfer',
    receiverType: 'Receiver Type',
    subscriptionType: 'Contract type',
    specialties: 'Specialties',
    date: {
      recent: 'Recent',
      startDate: 'Start Date',
      endDate: 'End Date',
      anyTime: 'Anytime',
      olderThanAWeek: 'A week ago',
      olderThanAMonth: 'A month ago',
      olderThanSixMonths: '6 months ago',
      olderThanOneYear: '1 year ago',
      customRange: 'Specific Dates',
      singleDate: 'Date',
      to: 'to',
    },
    datePicker: {
      more: 'more...',
    },
    asc: 'A-Z',
    desc: 'Z-A',
    yes: 'Yes',
    no: 'No',
    orderBy: 'Order by',
    status: 'Status',
    city: 'City',
    cities: 'Cities',
    state: 'State',
    country: 'Country',
    deleted: 'Deleted',
    realEstate: 'Real Estate',
    searchForRealEstate: 'Search for real estate',
    searchForAsaasCustomer: 'Search for ASAAS customer',
    hostOnboardingStep: 'Onboarding Step',
    hostOnboardingCoursePercentage: 'Course Percentage',
    startedOnboardingTrainingAt: 'Started training on',
    category: 'Category',
    noData: 'No results',
    realtyCode: 'Real Estate Code',
    userType: 'User Type',
    appointmentCode: 'Appointment Code',
    totalValue: 'Total Value',
    older: 'Older',
    newer: 'Newer',
    appointmentDate: 'Appointment date',
    hostName: 'Host name',
  },
  week: {
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
    SUNDAY: 'Sunday',
  },
  table: {
    noResults: 'No results',
    noServiceStatus: 'No status to display',
    searchText: 'Search',
    loading: 'Loading... Please wait',
    useTheFiltersToShowData: 'Use the filters to search for results',
  },
  hostInvoices: {
    firstHalf: 'First fortnight',
    secondHalf: 'Second fortnight',
    realEstate: 'Client',
    headers: {
      code: 'Scheduling Code',
      transactionId: 'Transaction',
      createdAt: 'Created at',
      description: 'Description',
      value: 'Value',
    },
    total: 'Total',
  },
  viewOptions: {
    label: 'View',
    default: 'Default',
    compact: 'Compact',
    list: 'List',
    pendentActions: 'Pending Actions',
  },
  formLabels: {
    date: 'Date',
    hour: 'Hour',
    code: 'Code',
  },
  upload: {
    label: 'Drag and drop files here',
    singleLabel: 'Drag and drop the file here',
    or: 'or',
    select: 'Select',
    exclude: 'Delete',
    photos: 'Photos',
    videos: 'Videos',
    delete: {
      title: 'This is an irreversible action',
      deleteThis: 'Do you want to delete this file: {value}',
      deleteSelected: 'Do you want to delete the selected {value} file(s)?',
      deleteAll: 'Do you want to delete all files?',
    },
    success: {
      uploaded: 'Successfully uploaded',
      excluded: 'File successfully deleted',
    },
    error: {
      failed: 'Failed to upload file',
      nameOrExtension: 'File name too long or missing extension',
    },
  },
  currency: {
    symbol: '$',
    decimalType: '.00',
  },
  recharge: {
    rechargeList: 'Recharge List',
    with: 'Recharge with',
    select: 'Select the',
    rechargeType: 'recharge type',
    cardInformations: 'Card Information',
    otherInformations: 'Other Information',
    comment: 'Comment',
    billet: {
      title: 'Bank Slip',
      successMessage: 'Successfully generated bank slip!',
      warningMessage: 'Attention, the credit will only be available on the platform after the compensation of the bank slip, which may take 3 business days',
      download: 'Click here to download the bank slip',
      withBillet: 'Recharge with bank slip',
      billetDownload: 'Download bank slip',
      billetInfo: 'Information about bank slips',
    },
    card: {
      title: 'Credit Card',
      successMessage: 'Payment successfully made!',
      withCard: 'Recharge with credit card',
    },
    pix: {
      title: 'PIX',
      withPix: 'Recharge with PIX',
      payPix: 'Pay with PIX',
      successMessage: 'Payment successfully made!',
      description: 'Use your phone’s scanner or copy and paste the PIX code to make the payment',
    },
    navigation: {
      goBack: 'Go back',
    },
    label: {
      code: 'Code',
      type: 'Type',
      date_created: 'Created date',
      due_date: 'Due date',
      real_estate: 'Real Estate',
      amount: 'Amount',
      status: 'Status',
      attachments: 'Attachments',
      advanced: 'Advanced',
      notAdvanced: 'Not Advanced',
      advanceBalance: 'Advance balance',
      undoAdvanceBalance: 'Undo advance balance',
      confirmAdvanceBalance: 'Confirm advance balance',
      confirmUndoAdvanceBalance: 'Confirm undo advance balance',
      isAdvancedBalance: 'Advanced balance?',
      confirm: 'Confirm',
      comment: 'Comment',
    },
    hint: {
      advanceBalanceWarning: 'Attention! You are about to advance the balance of this recharge before the billet is compensated. Are you sure about this?',
      undoAdvanceBalanceWarning: 'Attention! You are about to undo the advance balance of this recharge, this will generate a negative charge to the customer. Are you sure about this?',
      negativePaymentWarning: "The following hosts have negative values: {hosts}. Are you sure you want to continue with the payment?"
    },
    status: {
      PENDING: 'Pending',
      RECEIVED: 'Received',
      CONFIRMED: 'Confirmed',
      OVERDUE: 'Overdue',
    },
    paymentInfo: {
      title: 'Payment Information',
      billet: 'Compensation within 3 business days',
      credit: 'Compensation immediately after bank release',
      pix: 'Compensation instantly after payment',
      billetCompleteText: 'Boletos may take up to 3 business days to be compensated, this varies from bank to bank, and also depending on the time it was made. Your credits will be added after the billet compensation.',
    },
    lowAvailabilityBalance: {
      currentBalance: 'Current balance',
      requestMore: 'Request more credits',
    },
  },
  question: {
    label: {
      answerOptions: 'Answer Options',
      type: 'Type',
    },
    type: {
      label: 'Response Type',
      BOOLEAN: 'Boolean',
      NUMERIC: 'Numeric',
      ENUM: 'Multiple Choice Text',
      TEXT: 'Textual',
      FILE: 'File',
    },
    actions: {
      addQuestion: 'Add Question',
      editQuestion: 'Edit',
      removeQuestion: 'Delete',
    },
    modals: {
      confirmDeleteQuestion: {
        title: 'Confirm',
        text: 'Are you sure you want to delete the question:',
        buttons: {
          cancel: 'Cancel',
          confirm: 'Confirm',
        },
      },
    },
    delete: {
      deleteQuestion: {
        successMessage: 'Question successfully deleted',
      },
    },
    edit: {
      successMessage: 'Question updated successfully',
    },
    create: {
      label: 'Question',
      answer: 'Answer',
      required: 'Required',
      createAlert: 'Notify Answer',
      successMessage: 'Question created successfully',
      createButton: 'Save Question and Answer',
      cancel: 'Cancel',
      typeSelect: 'Select a question type',
      typeSelectPlaceholder:'Enter the address',
      minSize: 'Minimum size',
      zeroForUnlimited: '0 for unlimited',
      confirmTypeChange: {
        title: 'Confirm Type Change',
        text: 'Changing the question type will delete the answers. Are you sure you want to change it?',
        buttons: {
          cancel: 'Cancel',
          confirm: 'Confirm',
        },
      },
      actions: {
        addAnswer: 'Add multiple-choice answer',
      },
      type: {
        label: 'Response Type',
        BOOLEAN: 'Boolean',
        NUMERIC: 'Numeric',
        ENUM: 'Multiple Choice Text',
        TEXT: 'Textual',
        FILE: 'File',
      },
    },
  },
  questionnaire: {
    label: {
      question: 'Question',
      answer: 'Answer',
      list: {
        type: 'Type',
        name: 'Name',
        createdAt: 'Created At',
        published: 'Published',
        mustBeSent: 'Must be sent',
      },
      type: {
        DEFAULT: 'Default',
        CUSTOM: 'Customized',
      },
      create: {
        name: 'Name',
        type: 'Type',
        mustBeSent: 'Must be sent',
        title: 'New Questionnaire',
        serviceType: 'Service Types',
      },
      published: {
        true: 'Published',
        false: 'Not Published',
      },
      mustBeSent: {
        true: 'Must be sent',
        false: 'Must not be sent',
      },
      successCreation: 'Questionnaire created successfully',
      successPublish: 'Questionnaire published successfully',
      successUpdate: 'Questionnaire updated successfully',
      update: 'Edit Questionnaire',
    },
    actions: {
      goToQuestion: 'View Questions',
      publish: 'Publish',
      edit: 'Edit',
      print: 'Print',
    },
  },
  roles: {
    ROLE_ADMIN: 'Administrator',
    ROLE_HOST: 'Host',
    ROLE_REAL_ESTATE: 'Real Estate',
    ROLE_INSPECTOR: 'Inspector',
    ROLE_REAL_ESTATE_OPERATOR: 'Real Estate Operator',
    ROLE_SUPPORT: 'Support',
    ROLE_HAUSEFUL_FINANCIAL: 'Hauseful Financial',
    ROLE_REAL_ESTATE_FINANCIAL: 'Real Estate Financial',
    ROLE_PEOPLE: 'People Hauseful',
    ROLE_HAUSEFUL_OPERATOR: 'Hauseful Operator',
    ROLE_PARTNER: 'Hauseful Partner',
    ROLE_SERVICE_PROVIDER: 'Service Provider',
    undefined: '---',
  },
  forms: {
    completeName: 'Full Name',
    email: 'Email',
    cpf: 'Driver License Number',
    document: `Driver's license`,
    phone: 'Phone',
    address: 'Address',
    addressNumber: 'Number',
    addressComplement: 'Complement',
    zipCode: 'ZIP Code',
    nameAsCreditCard: 'Name (as displayed on the card)',
    creditCardNumber: 'Card Number',
    cardDate: 'Expiry Date',
    cardCvv: 'CVC',
    city: 'City',
    countryCode: 'Country Code',
    cpfCnpj: `Driver's license`,
    invalidBirthDate: 'Invalid birth date',
    invalidDateDay: 'The day seems invalid',
    invalidDateMonth: 'The month seems invalid',
    invalidDateYear: 'The year seems invalid',
    citySelect: 'Select a city',
    invalidZipCode: 'The ZIP Code seems invalid',
    zipCodeNotFound: 'The ZIP Code does not seem to belong to the address',
    expiredMonth: 'Invalid expiration month',
    expiredYear: 'Invalid expiration year',
    timesGone: 'The time has passed. Click on "more..." to see other available times',
    dateHint: 'DD/MM/YYYY',
    sending: 'Sending...',
    loading: 'Loading...',
    cancel: 'Cancel',
    save: 'Save',
    update: 'Update',
    delete: 'Delete',
    edit: 'Edit',
    confirm: 'Confirm',
    removeItemMessage: 'Do you want to remove this item?',
    visualize: 'Visualize',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    logo: 'Logo',
  },
  myPlan: {
    label: {
      unnamedPlan: 'Plan',
      plan: 'Plan',
      status: 'Status',
      value: 'Amount',
      installments: '{amount} in {count}x',
      term: 'Term',
      nextRenewal: 'Next renewal',
      seats: 'Included users',
      myCard: 'My card',
      scheduledChange: 'Your plan changes to {plan} on {date}. Nothing changes until then.',
    },
    status: {
      ACTIVE: 'Active',
      TRIALING: 'Free trial',
      PENDING: 'Awaiting payment',
      PAYMENT_FAILED: 'Payment failed',
      EXPIRED: 'Expired',
      CANCELLED: 'Cancelled',
      NONE: 'No subscription',
    },
    state: {
      notSubscribedTitle: 'No active plan',
      notSubscribedDescription: 'Your company does not have an active subscription yet.',
      notReadyTitle: 'We are setting up your account',
      notReadyDescription: 'Billing details will be available in a moment.',
      unavailableTitle: 'Could not load your plan',
      unavailableDescription: 'Please try again in a moment.',
    },
    action: {
      retry: 'Try again',
      updateCard: 'Replace card',
    },
    card: {
      title: 'Replace card',
      description: 'The new card replaces the current one on upcoming charges. We keep only the brand and the last 4 digits.',
      confirm: 'Save card',
      cancel: 'Cancel',
      success: 'Card updated.',
      error: {
        CARD_REJECTED: 'We could not validate this card. Check the details or try another one.',
        CUSTOMER_DATA_INCOMPLETE: 'Your company record is missing an address or phone number. Contact support to finish this.',
        notReady: 'Your account is still being set up. Please try again in a moment.',
        unavailable: 'We could not replace the card right now. Your current card is still active.',
      },
    },
  },
  trial: {
    plan: {
      message: 'You are on a free trial until {date}.',
    },
    footer: {
      label: 'Free trial',
      endsToday: 'ends today',
      oneDayLeft: '1 day left',
      daysLeft: '{count} days left',
      seePlan: 'See my plan',
    },
  },
  profile: {
    label: {
      edit: 'Edit Profile',
      updatePassword: 'Change Password',
      apiToken: 'Token',
      updateRealEstate: 'Edit Company',
      updateCountry: 'Update Country',
      updateLanguage: 'Change Language',
      myPlan: 'My plan',
    },
    updatePassword: {
      label: {
        currentPassword: 'Current Password',
        newPassword: 'New Password',
        repeatNewPassword: 'Repeat New Password',
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
      messages: {
        passwordsDoNotMatch: 'Passwords do not match',
      }
    },
    updateRealEstate: {
      label: {
        webhookUrl: 'Webhooks Callback URL',
        useCancelationLimit: 'Use Cancellation Limit',
        cancelationLimit: 'Cancellation Limit',
        useExpirationService: 'Use Service Limit (hours)',
        expirationHours: 'Service Limit (hours)',
        confirm: 'Confirm',
        cancel: 'Cancel',
        successMessage: 'Data Updated Successfully!',
        allowKeyPickup: 'Allows key pickup',
        hcheckSyncEnabled: "I'm using HCheck (Enable Sync)",
        showPropertyManagerDataOnConfirmationEmail: 'Show property manager data on confirmation e-mail',
        receiveConfirmationMailCopy: 'Receive copy of notices to the tenant',
        confirmationEmailObservations: 'Confirmation e-mail comments',
        disputeCreationDaysLimit: 'Dispute deadline (business days)',
        disputeCreationDaysLimitHint: 'Leave empty to use the default of 11 business days',
      },
    },
  },
  batchSchedule: {
    label: {
      realtyCode: 'Property Code',
      date: 'Date',
      code: 'Code',
      type: 'Type',
      csvExample: 'Spreadsheet template',
      title: 'Schedule via spreadsheet',
      appointments: 'Appointments',
      drafts: 'Drafts',
      attachment: 'Attachment',
      realEstate: 'Real estate',
      branch: 'Branch',
    },
    buttons: {
      schedule: 'Schedule',
      back: 'Back',
      ok: 'OK',
      downloadFile: 'Download file',
    },
    message: {
      appointmentsFound: 'The following appointments were found in your sheet:',
      explanation: 'To create multiple {value} at once, download the template spreadsheet and replace the data with that of your property.',
      attachmentInfo: 'The selected attachment will be used in all appointments/drafts',
      appointmentsNotImported: 'Some appointments were not imported due to errors. Click the button below to download a spreadsheet (CSV) containing only the appointments with errors.',
    },
    closeModal: {
      title: 'Confirmation',
      message: 'Not all services were scheduled. Do you want to close the window?',
    },
  },
  partner: {
    filter: {
      orderBy: 'Sort (Name)',
      date: 'Period (Creation Date)',
    },
    label: {
      name: 'Name',
      description: 'Description',
      dateCreated: 'Creation Date',
      asaasWalletId: 'Asaas Wallet Code',
      historyEmail: 'History email',
      historyEmailHint: 'Email where copies of the emails sent to tenants are sent',
      linked: 'Linked',
      notLinked: 'Not Linked',
      asaas: 'Asaas',
    },
    action: {
      save: 'Save',
      update: 'Edit Partner',
      create: 'Create Partner',
      cancel: 'Cancel',
      delete: 'Remove Partner',
    },
    hints: {
      delete: 'Do you really want to remove this partner?',
    },
    noData: 'No results. Search for the name of the partner',
  },
  rentOut: {
    status: 'Status',
    complianceAccepted: 'Budget Accepted',
    complianceNotAccepted: 'Budget Not Accepted',
    noComplianceFound: 'No Nonconformities Found',
    keyWithHost: 'Key is with Host',
    keyWithTenant: 'Key is with Tenant',
    termWasSent: 'Term was Sent',
    termNotSent: 'Term was Not Sent',
    tenantDidNotWantToPayOnTime: 'Tenant Did Not Want to Pay On Time',
    conflictTenantDidNotAgree: 'Tenant Does Not Agree with the Budget',
    confirmation: 'Do you confirm that you included a valid keys delivery/termination report and attached or provided tested links for photos and other documents required for service execution?',
    termData: {
      key: 'Key',
      name: 'Name',
      signers: 'Signatories',
      signatureDate: 'Signature Date',
      termNotSignedYet: 'Pending Signature',
      downloadTerm: 'Download Term',
    },
    replaceTerm: 'Replace Term',
    replaceTermWarnMessage: 'Attention, you are about to replace the termination report for this appointment. This action cannot be undone!',
    newTerm: 'New Term',
    waitingPayment: 'Waiting for Payment',
  },
  keyInfo: {
    NOTHING_TO_EXECUTE_KEYS_DELIVERED: 'No nonconformities and keys delivered.',
    SERVICE_PAID_KEYS_DELIVERED: 'Tenant accepted the budget and delivered the keys.',
    SERVICE_NOT_PAID_KEYS_DELIVERED: 'Tenant wants to deliver the keys but does not agree to pay on the spot.',
    SERVICE_NOT_PAID_KEYS_NOT_DELIVERED: 'Tenant still has the keys and will perform the repair on their own.',
  },
  appointmentDashboard: {
    label: {
      code: 'Code',
      firstAppointmentDate: '1st Appointment',
      deliverySLA: 'Delivery SLA',
      firstAcceptanceSLA: '1st Acceptance SLA',
      firstAppointmentSLA: '1st Appointment SLA',
      deliveryAndFirstAppointmentDifference: 'SLA Difference',
      acceptanceDate: 'Accepted',
      dateCreated: 'Created',
      date: 'Date',
      realtyCode: 'Property(ies)',
      city: 'City(ies)',
      status: 'Status',
      cancelDate: 'Cancellation Date',
      cancelReason: 'Reason for Cancellation',
      lastUpdated: 'Last Updated',
      host: 'Host',
      type: 'Type',
      externalCode: 'External Code',
      tags: 'Tags',

      firstAppointmentDateComp: 'First Appointment Date',
      deliverySLAComp: 'Delivery SLA',
      firstAcceptanceSLAComp: 'First Acceptance SLA',
      firstAppointmentSLAComp: 'First Appointment SLA',
      deliveryAndFirstAppointmentDifferenceComp: 'SLA Difference (Delivery - First Appointment)',
      acceptanceDateComp: 'Acceptance Date',
      dateCreatedComp: 'Created Date',
      dateComp: 'Date',
      realtyCodeComp: 'Property Code(s)',
      cancelDateComp: 'Cancellation Date',
      cancelReasonComp: 'Cancellation Reason',
      lastUpdatedComp: 'Last Updated Date',
      hostComp: 'Host',
      typeComp: 'Type',
      externalCodeComp: 'External Code',
      tagsComp: 'Tags',
    },
    tag: {
      add: 'Add',
      tags: 'Tags',
      cancel: 'Cancel',
    },
  },
  cancelRequest: {
    cancelReason: 'Cancellation Reason',
  },
  clickToCopy: 'Click to Copy',
  language: {
    label: 'Language',
    location: 'Location',
    country: 'Country',
    currentCountry: 'Current country',
    currentLanguage: 'Current language',
    australia: 'Australia',
    brazil: 'Brazil',
  },
  userChecklistModal: {
    title: 'Link user with Checklist app',
    message: `Do you want to link the user '{user}' with the Checklist app?`,
    cancel: 'Cancel',
    confirm: 'Link',
    successfullyCreated: 'User linked with success',
    successfullyUpdated: 'Successful Differentiation Model',
    successfullyDeleted: 'Model successfully unlinked',
    baseReportRequired: 'Requires base report?',
    baseReportRequiredInfo: 'When scheduling this service, the client picks a finished report of the property, which is the base of the comparison report.',
    baseReport: 'Base report',
    realEstate: 'Real estate (optional)',
    realEstateHint: 'Empty links the default model of the service. With a real estate, the model applies only to it and overrides the default.',
    realEstateColumn: 'Real estate',
  },
  dispute: {
    filters: {
      status: 'Status',
      type: 'Type',
      owner: 'Owner',
      sla: 'SLA',
      slaBreachedOnly: 'Overdue only',
      negligence: 'Negligence',
      withNegligence: 'With negligence',
      withoutNegligence: 'Without negligence',
    },
    table: {
      headers: {
        code: 'Code',
        realty: 'Realty',
        host: 'Host',
        createdAt: 'Created At',
        status: 'Status',
        items: 'Items',
        type: 'Type',
        owner: 'Owner',
        sla: 'SLA',
      },
      loading: 'Loading... Please wait',
      noData: 'No results',
    },
    status: {
      PENDING: 'Pending',
      FINISHED: 'Finished',
    },
    type: {
      REVIEW: 'Quality',
      OBJECTION: 'Objection',
      AUDIT: 'Audit',
    },
    item: {
      status: {
        PENDING: 'Pending',
        APPROVED: 'Approved',
        REJECTED: 'Rejected',
      },
      negligence: 'Negligence',
    },
    ownerType: {
      HAUSEFUL: 'Hauseful',
      CUSTOMER: 'Real Estate Agency',
      SERVICE_PROVIDER: 'Third Party',
    },
    sla: {
      remaining: '{duration} remaining',
      breached: '{duration} overdue',
      resolvedIn: 'Resolved in {duration}',
      hasOverdueItems: 'Has overdue SLA items',
      withinDeadline: 'All items within SLA deadline',
      finished: 'Dispute finished',
    },
  },

  operationTypes: {
    title: 'Worker Type',
    serviceOptions: 'Worker type options',
    operationTypes: 'Operation Types',
    operationType: 'Operation Type',
    selectOperationTypes: 'Select operation types',
    selectProfessional: 'Select a team member',
    branchSelectedTag: 'Selected',
    withoutBranch: 'Without branch',
    responsibleTeam: 'Responsible Team',
    options: {
      host: {
        text: 'Hauseful',
        description: 'Allow Hauseful hosts to perform services.',
      },
      internal: {
        text: 'Internal',
        description: 'Allow the client\'s internal team to perform services.',
      },
      thirdParty: {
        text: 'Suppliers',
        description: 'Allow suppliers (third parties) to perform services.',
      },
    },
    hints: {
      canSelectMultipleOptions: 'You can select multiple options.',
      typeToFilterProfessionals: 'Type to filter the professionals',
      internalDailyServiceLimit: 'Applies to the internal team only. Hauseful hosts and suppliers keep the limit of 8.',
    },
    internalDailyServiceLimit: 'Internal team daily service limit',
    types: {
      HOST: 'Hauseful Host',
      INTERNAL: 'Internal Team',
      THIRD_PARTY: 'Suppliers (third parties)',
    },
  },
}

const en = Object.assign(enGroup, enInvoices, enCategory, enItem, enPriceTable, enItemPrice, enSplit, enQuote, enVendors, enCharge, enHostRating, enHausefulUsers, enMapDrawing, enImpersonate, enServiceProviders, enFinancialReport, enDivergence)

export default en
